"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Helper pour convertir snake_case en camelCase et normaliser les styles_properties
const normalizeStylesProperties = (props = {}) => {
  const snakeToCamelMap = {
    primary_color: 'primaryColor',
    secondary_color: 'secondaryColor',
    accent_color: 'accentColor',
    background_color: 'backgroundColor',
    text_color: 'textColor',
    price_color: 'priceColor',
    card_background: 'cardBackground',
    font_family: 'fontFamily',
    show_emoji: 'showEmoji'
  };
  const normalized = {
    ...props
  };
  Object.entries(snakeToCamelMap).forEach(([snake, camel]) => {
    if (props[snake] !== undefined && props[camel] === undefined) {
      normalized[camel] = props[snake];
    }
  });
  return normalized;
};

/**
 * ProductDetailModal - Modal de détail produit avec animations
 * @param {Object} product - Le produit à afficher
 * @param {Function} onClose - Callback pour fermer le modal
 * @param {Function} uri_transformer - Transformateur d'URL pour les images
 * @param {string} template_name - Nom du template ('default' ou 'classic')
 * @param {Object} styles_properties - Propriétés de style personnalisées
 */
const ProductDetailModal = ({
  product,
  onClose,
  uri_transformer = url => url,
  template_name = 'default',
  styles_properties = {}
}) => {
  // Sélection du template
  if (template_name === 'classic') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalClassic, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'moderne') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalModerne, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'prestige') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalPrestige, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'street') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalStreet, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'tropical') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalTropical, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'medieval') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalMedieval, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'light') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalLight, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'friterie') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalFriterie, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'pizzeria') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalPizzeria, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  if (template_name === 'patisserie') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalPatisserie, {
      product: product,
      onClose: onClose,
      uri_transformer: uri_transformer,
      styles_properties: styles_properties
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDetailModalDefault, {
    product: product,
    onClose: onClose,
    uri_transformer: uri_transformer,
    styles_properties: styles_properties
  });
};

// ============================================
// TEMPLATE DEFAULT
// ============================================
const ProductDetailModalDefault = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#667eea',
    secondaryColor = '#764ba2',
    accentColor = '#f093fb',
    backgroundColor,
    textColor = '#ffffff',
    priceColor = '#10b981',
    cardBackground
  } = normalizedProps;
  (0, _react.useEffect)(() => {
    requestAnimationFrame(() => setIsVisible(true));
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const images = product.images || [];
  const prices = product.prices || [];
  const allergens = product.allergens || [];
  const ingredients = product.ingredients || [];
  const tags = product.tags || [];
  const getDefaultImage = () => {
    if (images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return images.indexOf(img);
    }
    return 0;
  };
  const getDefaultPrice = () => {
    if (prices.length === 0) return null;
    if (product.default_price_id) {
      const price = prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85BB2F',
      'C': '#FECB02',
      'D': '#EE8100',
      'E': '#E63E11'
    };
    return colors[score] || '#999';
  };
  (0, _react.useEffect)(() => {
    const defaultIdx = getDefaultImage();
    if (defaultIdx !== null) setCurrentImageIndex(defaultIdx);
  }, [product]);
  const currentImage = images[currentImageIndex]?.image_url;
  const defaultPrice = getDefaultPrice();

  // Styles dynamiques
  const dynamicMainPriceStyle = {
    ...mainPriceStyle,
    background: `linear-gradient(135deg, ${priceColor} 0%, ${priceColor}dd 100%)`
  };
  const dynamicImageContainerStyle = {
    ...imageContainerStyle,
    background: `linear-gradient(135deg, ${primaryColor}33 0%, ${secondaryColor}33 100%)`
  };
  const dynamicModalStyle = {
    ...modalStyle,
    ...(cardBackground && {
      background: cardBackground
    })
  };
  const dynamicTitleStyle = {
    ...titleStyle,
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
  };
  const dynamicSectionTitleStyle = {
    ...sectionTitleStyle,
    color: primaryColor
  };
  const dynamicTagStyle = {
    ...tagStyle,
    borderColor: `${primaryColor}33`,
    color: primaryColor
  };
  const dynamicNavButtonStyle = {
    ...navButtonStyle,
    background: `${primaryColor}cc`
  };
  const dynamicIndicatorActiveStyle = {
    background: primaryColor
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...overlayStyle,
      opacity: isVisible ? 1 : 0
    },
    onClick: handleClose,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...dynamicModalStyle,
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.95)',
        opacity: isVisible ? 1 : 0
      },
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: closeButtonStyle,
        onClick: handleClose,
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: dynamicImageContainerStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: imageStyle
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: imagePlaceholderStyle,
          children: "\uD83C\uDF7D\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: imageOverlayStyle
        }), images.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...dynamicNavButtonStyle,
              left: '1rem'
            },
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            children: "\u2190"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...dynamicNavButtonStyle,
              right: '1rem'
            },
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            children: "\u2192"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: indicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              style: {
                ...indicatorStyle,
                background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.4)',
                transform: i === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
              },
              onClick: () => setCurrentImageIndex(i)
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: badgesContainerStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...badgeStyle,
              background: 'linear-gradient(135deg, #f97316, #ea580c)'
            },
            children: "\u2B50 Vedette"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...badgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["Nutri-Score ", product.nutrition_score]
          })]
        }), defaultPrice !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: dynamicMainPriceStyle,
          children: formatPrice(defaultPrice)
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: contentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: dynamicTitleStyle,
          children: product.name
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: descriptionStyle,
          children: product.description
        }), tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: sectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: dynamicSectionTitleStyle,
            children: "\uD83C\uDFF7\uFE0F Tags"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: tagsContainerStyle,
            children: tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: dynamicTagStyle,
              children: tag
            }, i))
          })]
        }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: sectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: dynamicSectionTitleStyle,
            children: "\u26A0\uFE0F Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: allergensContainerStyle,
            children: allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: allergenItemStyle,
              title: allergen.description || allergen,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: allergenIconStyle,
                children: allergen.icon || '⚠️'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: allergenNameStyle,
                children: allergen.name || allergen
              })]
            }, i))
          })]
        }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: sectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: dynamicSectionTitleStyle,
            children: "\uD83E\uDD57 Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: ingredientsContainerStyle,
            children: ingredients.map((ingredient, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: ingredientItemStyle,
              children: ingredient
            }, i))
          })]
        }), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: sectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: dynamicSectionTitleStyle,
            children: "\uD83D\uDCB0 Prix disponibles"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: pricesContainerStyle,
            children: prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...priceItemStyle,
                ...(price.id === product.default_price_id ? priceItemDefaultStyle : {})
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  ...priceValueStyle,
                  color: priceColor
                },
                children: formatPrice(price.price)
              }), price.id === product.default_price_id && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  ...priceDefaultBadgeStyle,
                  color: priceColor
                },
                children: "Par d\xE9faut"
              })]
            }, i))
          })]
        }), (product.available_from || product.available_to || product.available_days?.length < 7) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: sectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: dynamicSectionTitleStyle,
            children: "\uD83D\uDD50 Disponibilit\xE9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            style: availabilityStyle,
            children: [product.available_from && product.available_to && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: ["De ", product.available_from.slice(0, 5), " \xE0 ", product.available_to.slice(0, 5)]
            }), product.available_days && product.available_days.length < 7 && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                display: 'block',
                marginTop: '0.25rem'
              },
              children: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].filter((_, i) => product.available_days.includes(i)).join(', ')
            })]
          })]
        })]
      })]
    })]
  });
};

// ============================================
// TEMPLATE CLASSIC
// ============================================
const ProductDetailModalClassic = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#6b2d3a',
    secondaryColor = '#c9a66b',
    accentColor = '#8b7355',
    priceColor = '#6b2d3a'
  } = normalizedProps;
  (0, _react.useEffect)(() => {
    requestAnimationFrame(() => setIsVisible(true));
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const images = product.images || [];
  const prices = product.prices || [];
  const allergens = product.allergens || [];
  const ingredients = product.ingredients || [];
  const tags = product.tags || [];
  const getDefaultImage = () => {
    if (images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return images.indexOf(img);
    }
    return 0;
  };
  const getDefaultPrice = () => {
    if (prices.length === 0) return null;
    if (product.default_price_id) {
      const price = prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#2d5a27',
      'B': '#5a7a2d',
      'C': '#b8860b',
      'D': '#cd853f',
      'E': '#8b4513'
    };
    return colors[score] || '#8b7355';
  };
  (0, _react.useEffect)(() => {
    const defaultIdx = getDefaultImage();
    if (defaultIdx !== null) setCurrentImageIndex(defaultIdx);
  }, [product]);
  const currentImage = images[currentImageIndex]?.image_url;
  const defaultPrice = getDefaultPrice();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...classicOverlayStyle,
      opacity: isVisible ? 1 : 0
    },
    onClick: handleClose,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: classicKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...classicModalStyle,
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.95)',
        opacity: isVisible ? 1 : 0
      },
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          height: '6px',
          background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...classicCloseButtonStyle,
          color: primaryColor,
          borderColor: secondaryColor
        },
        onClick: handleClose,
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicImageContainerStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: classicImageStyle
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: classicImagePlaceholderStyle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '4rem',
              color: secondaryColor
            },
            children: "\u2619"
          })
        }), images.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...classicNavButtonStyle,
              left: '1rem',
              color: primaryColor,
              borderColor: secondaryColor
            },
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            children: "\u2039"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...classicNavButtonStyle,
              right: '1rem',
              color: primaryColor,
              borderColor: secondaryColor
            },
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            children: "\u203A"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: classicIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              style: {
                ...classicIndicatorStyle,
                background: i === currentImageIndex ? primaryColor : secondaryColor
              },
              onClick: () => setCurrentImageIndex(i)
            }, i))
          })]
        }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...classicHighlightBadgeStyle,
            background: primaryColor
          },
          children: "\u2605 Coup de c\u0153ur"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: classicContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            textAlign: 'center',
            color: secondaryColor,
            marginBottom: '1rem'
          },
          children: "\u2767"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...classicTitleStyle,
            color: primaryColor
          },
          children: product.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            width: '60px',
            height: '1px',
            background: secondaryColor,
            margin: '0 auto 1rem'
          }
        }), defaultPrice !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...classicMainPriceStyle,
            color: priceColor
          },
          children: formatPrice(defaultPrice)
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...classicDescriptionStyle,
            color: accentColor
          },
          children: product.description
        }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicNutriScoreContainerStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '0.8rem',
              color: accentColor,
              marginRight: '0.5rem'
            },
            children: "Nutri-Score"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              padding: '0.25rem 0.6rem',
              fontSize: '0.85rem',
              fontWeight: '600',
              color: '#fff',
              background: getNutriScoreColor(product.nutrition_score),
              borderRadius: '3px'
            },
            children: product.nutrition_score
          })]
        }), tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...classicSectionTitleStyle,
              color: primaryColor
            },
            children: "Caract\xE9ristiques"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: classicTagsContainerStyle,
            children: tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                ...classicTagStyle,
                color: primaryColor,
                borderColor: secondaryColor
              },
              children: tag
            }, i))
          })]
        }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...classicSectionTitleStyle,
              color: primaryColor
            },
            children: "Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: classicAllergensContainerStyle,
            children: allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: classicAllergenItemStyle,
              title: allergen.description || allergen,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: '1rem'
                },
                children: allergen.icon || '⚠'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: classicAllergenNameStyle,
                children: allergen.name || allergen
              })]
            }, i))
          })]
        }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...classicSectionTitleStyle,
              color: primaryColor
            },
            children: "Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              ...classicIngredientsTextStyle,
              color: accentColor
            },
            children: ingredients.join(' • ')
          })]
        }), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...classicSectionTitleStyle,
              color: primaryColor
            },
            children: "Tarifs"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: classicPricesContainerStyle,
            children: prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...classicPriceItemStyle,
                borderColor: price.id === product.default_price_id ? primaryColor : secondaryColor,
                background: price.id === product.default_price_id ? `${primaryColor}0d` : 'transparent'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  ...classicPriceValueStyle,
                  color: priceColor
                },
                children: formatPrice(price.price)
              }), price.id === product.default_price_id && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: '0.65rem',
                  color: primaryColor,
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                },
                children: "Recommand\xE9"
              })]
            }, i))
          })]
        }), (product.available_from || product.available_to || product.available_days?.length < 7) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: classicSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...classicSectionTitleStyle,
              color: primaryColor
            },
            children: "Disponibilit\xE9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            style: {
              ...classicAvailabilityStyle,
              color: accentColor
            },
            children: [product.available_from && product.available_to && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: ["De ", product.available_from.slice(0, 5), " \xE0 ", product.available_to.slice(0, 5)]
            }), product.available_days && product.available_days.length < 7 && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                display: 'block',
                marginTop: '0.25rem'
              },
              children: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'].filter((_, i) => product.available_days.includes(i)).join(', ')
            })]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            textAlign: 'center',
            color: secondaryColor,
            marginTop: '1.5rem'
          },
          children: "\u2766"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          height: '6px',
          background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
        }
      })]
    })]
  });
};

// ============================================
// CSS Keyframes
// ============================================
const keyframesCSS = `
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    @keyframes slideUp {
        from { transform: translateY(50px) scale(0.95); opacity: 0; }
        to { transform: translateY(0) scale(1); opacity: 1; }
    }
`;
const classicKeyframesCSS = `
    @keyframes classicFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    @keyframes classicSlideUp {
        from { transform: translateY(50px) scale(0.95); opacity: 0; }
        to { transform: translateY(0) scale(1); opacity: 1; }
    }
`;

// ============================================
// Styles DEFAULT
// ============================================
const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.85)',
  backdropFilter: 'blur(10px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  zIndex: 10000,
  transition: 'opacity 0.3s ease'
};
const modalStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '600px',
  maxHeight: '90vh',
  background: 'linear-gradient(145deg, #1a1a2e 0%, #16213e 100%)',
  borderRadius: '24px',
  overflow: 'hidden',
  boxShadow: '0 25px 80px rgba(0, 0, 0, 0.5)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
};
const closeButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  color: '#fff',
  background: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(10px)',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.2s ease'
};
const imageContainerStyle = {
  position: 'relative',
  height: '280px',
  background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)',
  overflow: 'hidden'
};
const imageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const imagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  fontSize: '5rem',
  opacity: 0.3
};
const imageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '60%',
  background: 'linear-gradient(to top, rgba(26, 26, 46, 1) 0%, transparent 100%)',
  pointerEvents: 'none'
};
const navButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '44px',
  height: '44px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  color: '#fff',
  background: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(10px)',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 5,
  transition: 'all 0.2s ease'
};
const indicatorsStyle = {
  position: 'absolute',
  bottom: '1rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px',
  zIndex: 5
};
const indicatorStyle = {
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const badgesContainerStyle = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  zIndex: 5
};
const badgeStyle = {
  padding: '0.4rem 0.75rem',
  fontSize: '0.75rem',
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: '#fff',
  borderRadius: '8px',
  backdropFilter: 'blur(10px)'
};
const mainPriceStyle = {
  position: 'absolute',
  bottom: '1rem',
  right: '1rem',
  padding: '0.75rem 1.25rem',
  fontSize: '1.5rem',
  fontWeight: '700',
  color: '#fff',
  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)',
  zIndex: 5
};
const contentStyle = {
  padding: '1.5rem 2rem 2rem',
  maxHeight: 'calc(90vh - 280px)',
  overflowY: 'auto'
};
const titleStyle = {
  fontSize: '1.8rem',
  fontWeight: '700',
  color: '#fff',
  margin: '0 0 0.75rem',
  letterSpacing: '-0.02em'
};
const descriptionStyle = {
  fontSize: '1rem',
  color: 'rgba(255, 255, 255, 0.7)',
  lineHeight: 1.6,
  margin: '0 0 1.5rem'
};
const sectionStyle = {
  marginBottom: '1.5rem'
};
const sectionTitleStyle = {
  fontSize: '0.95rem',
  fontWeight: '600',
  color: '#fff',
  margin: '0 0 0.75rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem'
};
const tagsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const tagStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.85rem',
  color: 'rgba(255, 255, 255, 0.8)',
  background: 'rgba(255, 255, 255, 0.08)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '8px'
};
const allergensContainerStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
  gap: '0.5rem'
};
const allergenItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.6rem 0.8rem',
  background: 'rgba(239, 68, 68, 0.1)',
  border: '1px solid rgba(239, 68, 68, 0.25)',
  borderRadius: '10px'
};
const allergenIconStyle = {
  fontSize: '1.1rem'
};
const allergenNameStyle = {
  fontSize: '0.85rem',
  fontWeight: '500',
  color: '#fca5a5'
};
const ingredientsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.4rem'
};
const ingredientItemStyle = {
  padding: '0.35rem 0.7rem',
  fontSize: '0.85rem',
  color: 'rgba(255, 255, 255, 0.7)',
  background: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  borderRadius: '6px'
};
const pricesContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem'
};
const priceItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.6rem 1rem',
  background: 'rgba(255, 255, 255, 0.05)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '10px'
};
const priceItemDefaultStyle = {
  background: 'rgba(16, 185, 129, 0.1)',
  borderColor: 'rgba(16, 185, 129, 0.3)'
};
const priceValueStyle = {
  fontSize: '1rem',
  fontWeight: '600',
  color: '#10b981'
};
const priceDefaultBadgeStyle = {
  fontSize: '0.7rem',
  fontWeight: '500',
  color: '#10b981',
  textTransform: 'uppercase'
};
const availabilityStyle = {
  fontSize: '0.95rem',
  color: 'rgba(255, 255, 255, 0.7)',
  margin: 0
};

// ============================================
// Styles CLASSIC
// ============================================
const classicOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(61, 44, 44, 0.85)',
  backdropFilter: 'blur(8px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  zIndex: 10000,
  transition: 'opacity 0.3s ease'
};
const classicModalStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '550px',
  maxHeight: '90vh',
  background: 'linear-gradient(180deg, #faf6f0 0%, #f5e6d3 100%)',
  overflow: 'hidden',
  boxShadow: '0 25px 80px rgba(107, 45, 58, 0.3)',
  border: '1px solid #e8dcc8',
  transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
};
const classicCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  background: '#fff',
  border: '1px solid',
  borderRadius: '0',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.2s ease',
  fontFamily: 'inherit'
};
const classicImageContainerStyle = {
  position: 'relative',
  height: '250px',
  background: '#f5e6d3',
  overflow: 'hidden'
};
const classicImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const classicImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};
const classicNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.5rem',
  background: '#fff',
  border: '1px solid',
  borderRadius: '0',
  cursor: 'pointer',
  zIndex: 5,
  transition: 'all 0.2s ease',
  fontFamily: 'inherit'
};
const classicIndicatorsStyle = {
  position: 'absolute',
  bottom: '0.75rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 5
};
const classicIndicatorStyle = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const classicHighlightBadgeStyle = {
  position: 'absolute',
  top: '0.75rem',
  left: '0.75rem',
  padding: '0.4rem 0.9rem',
  fontSize: '0.7rem',
  fontWeight: '400',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: '#f5e6d3',
  fontStyle: 'italic',
  fontFamily: "'Playfair Display', Georgia, serif"
};
const classicContentStyle = {
  padding: '1.5rem 2rem 2rem',
  maxHeight: 'calc(90vh - 250px)',
  overflowY: 'auto',
  fontFamily: "'Playfair Display', 'Cormorant Garamond', Georgia, serif"
};
const classicTitleStyle = {
  fontSize: '1.8rem',
  fontWeight: '400',
  fontStyle: 'italic',
  margin: '0 0 0.5rem',
  textAlign: 'center',
  letterSpacing: '0.03em'
};
const classicMainPriceStyle = {
  fontSize: '1.6rem',
  fontWeight: '400',
  fontStyle: 'italic',
  textAlign: 'center',
  marginBottom: '1rem'
};
const classicDescriptionStyle = {
  fontSize: '0.95rem',
  lineHeight: 1.7,
  margin: '0 0 1.5rem',
  textAlign: 'center',
  fontStyle: 'italic'
};
const classicNutriScoreContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.5rem'
};
const classicSectionStyle = {
  marginBottom: '1.5rem',
  paddingTop: '1rem',
  borderTop: '1px solid #e8dcc8'
};
const classicSectionTitleStyle = {
  fontSize: '0.9rem',
  fontWeight: '400',
  margin: '0 0 0.75rem',
  textAlign: 'center',
  textTransform: 'uppercase',
  letterSpacing: '0.15em'
};
const classicTagsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  justifyContent: 'center'
};
const classicTagStyle = {
  padding: '0.3rem 0.8rem',
  fontSize: '0.75rem',
  background: 'transparent',
  border: '1px solid',
  textTransform: 'uppercase',
  letterSpacing: '0.08em'
};
const classicAllergensContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
  justifyContent: 'center'
};
const classicAllergenItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.4rem',
  padding: '0.4rem 0.7rem',
  background: 'rgba(139, 69, 19, 0.08)',
  border: '1px solid rgba(139, 69, 19, 0.2)'
};
const classicAllergenNameStyle = {
  fontSize: '0.8rem',
  fontWeight: '400',
  color: '#8b4513'
};
const classicIngredientsTextStyle = {
  fontSize: '0.9rem',
  lineHeight: 1.8,
  margin: 0,
  textAlign: 'center',
  fontStyle: 'italic'
};
const classicPricesContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem',
  justifyContent: 'center'
};
const classicPriceItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  padding: '0.6rem 1rem',
  border: '1px solid'
};
const classicPriceValueStyle = {
  fontSize: '1.1rem',
  fontWeight: '400',
  fontStyle: 'italic'
};
const classicAvailabilityStyle = {
  fontSize: '0.9rem',
  margin: 0,
  textAlign: 'center',
  fontStyle: 'italic'
};

// ============================================
// TEMPLATE MODERNE (Futuriste/Cyberpunk)
// ============================================
const ProductDetailModalModerne = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [scanEffect, setScanEffect] = (0, _react.useState)(true);
  const [glitchEffect, setGlitchEffect] = (0, _react.useState)(false);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#00f0ff',
    secondaryColor = '#ff00ff',
    accentColor = '#00ff88',
    priceColor = '#00ff88',
    cardBackground = 'rgba(10, 10, 30, 0.95)'
  } = normalizedProps;
  (0, _react.useEffect)(() => {
    requestAnimationFrame(() => setIsVisible(true));
    document.body.style.overflow = 'hidden';

    // Effet de scan initial
    const scanTimer = setTimeout(() => setScanEffect(false), 500);
    return () => {
      document.body.style.overflow = '';
      clearTimeout(scanTimer);
    };
  }, []);

  // Glitch effect périodique
  (0, _react.useEffect)(() => {
    const glitchInterval = setInterval(() => {
      if (Math.random() > 0.7) {
        setGlitchEffect(true);
        setTimeout(() => setGlitchEffect(false), 100);
      }
    }, 3000);
    return () => clearInterval(glitchInterval);
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const images = product.images || [];
  const prices = product.prices || [];
  const allergens = product.allergens || [];
  const ingredients = product.ingredients || [];
  const tags = product.tags || [];
  const getDefaultImage = () => {
    if (images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return images.indexOf(img);
    }
    return 0;
  };
  const getDefaultPrice = () => {
    if (prices.length === 0) return null;
    if (product.default_price_id) {
      const price = prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#00ff88',
      'B': '#88ff00',
      'C': '#ffff00',
      'D': '#ff8800',
      'E': '#ff0044'
    };
    return colors[score] || primaryColor;
  };
  (0, _react.useEffect)(() => {
    const defaultIdx = getDefaultImage();
    if (defaultIdx !== null) setCurrentImageIndex(defaultIdx);
  }, [product]);
  const currentImage = images[currentImageIndex]?.image_url;
  const defaultPrice = getDefaultPrice();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...moderneOverlayStyle,
      opacity: isVisible ? 1 : 0
    },
    onClick: handleClose,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: moderneModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: moderneOverlayScanLinesStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...moderneModalContainerStyle,
        background: cardBackground,
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.9)',
        opacity: isVisible ? 1 : 0,
        filter: glitchEffect ? 'hue-rotate(90deg)' : 'none'
      },
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneModalCornerStyle,
          top: 0,
          left: 0,
          borderTopColor: primaryColor,
          borderLeftColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneModalCornerStyle,
          top: 0,
          right: 0,
          borderTopColor: primaryColor,
          borderRightColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneModalCornerStyle,
          bottom: 0,
          left: 0,
          borderBottomColor: primaryColor,
          borderLeftColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneModalCornerStyle,
          bottom: 0,
          right: 0,
          borderBottomColor: primaryColor,
          borderRightColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...moderneCloseButtonStyle,
          borderColor: primaryColor,
          color: primaryColor,
          boxShadow: `0 0 15px ${primaryColor}40`
        },
        onClick: handleClose,
        children: "\u2715"
      }), scanEffect && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...moderneScanBarModalStyle,
          background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneModalImageContainerStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: moderneModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              ...moderneModalHoloOverlayStyle,
              background: `linear-gradient(135deg, ${primaryColor}30 0%, transparent 50%, ${secondaryColor}30 100%)`
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalImageScanLinesStyle
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneModalImagePlaceholderStyle,
            color: primaryColor
          },
          children: "\u25C7"
        }), images.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...moderneModalNavButtonStyle,
              left: '1rem',
              borderColor: primaryColor,
              color: primaryColor
            },
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            children: "\u25C4"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...moderneModalNavButtonStyle,
              right: '1rem',
              borderColor: primaryColor,
              color: primaryColor
            },
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            children: "\u25BA"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              style: {
                ...moderneModalIndicatorStyle,
                background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.3)',
                boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none'
              },
              onClick: () => setCurrentImageIndex(i)
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...moderneModalBadgeStyle,
              background: `linear-gradient(135deg, ${secondaryColor} 0%, ${primaryColor} 100%)`,
              boxShadow: `0 0 15px ${secondaryColor}`
            },
            children: "\u2605 HOT"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...moderneModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score),
              boxShadow: `0 0 10px ${getNutriScoreColor(product.nutrition_score)}`
            },
            children: ["NUTRI ", product.nutrition_score]
          })]
        }), defaultPrice !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneModalMainPriceStyle,
            borderColor: priceColor,
            color: priceColor,
            boxShadow: `0 0 20px ${priceColor}50`
          },
          children: formatPrice(defaultPrice)
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: moderneModalContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...moderneModalTitleStyle,
            color: primaryColor,
            textShadow: `0 0 20px ${primaryColor}`
          },
          children: product.name?.toUpperCase()
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...moderneModalDataLineStyle,
            background: `linear-gradient(90deg, ${primaryColor}, transparent)`
          }
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: moderneModalDescriptionStyle,
          children: product.description
        }), tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...moderneModalSectionTitleStyle,
              color: primaryColor
            },
            children: "// TAGS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalTagsContainerStyle,
            children: tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                ...moderneModalTagStyle,
                borderColor: `${primaryColor}66`,
                color: primaryColor
              },
              children: ["#", tag.toLowerCase().replace(/\s/g, '_')]
            }, i))
          })]
        }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...moderneModalSectionTitleStyle,
              color: secondaryColor
            },
            children: "\u26A0 ALERTES"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalAllergensContainerStyle,
            children: allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...moderneModalAllergenItemStyle,
                borderColor: `${secondaryColor}66`
              },
              title: allergen.description || allergen,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  ...moderneModalAllergenIconStyle,
                  color: secondaryColor
                },
                children: allergen.icon || '⚠'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: secondaryColor
                },
                children: (allergen.name || allergen).toUpperCase()
              })]
            }, i))
          })]
        }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...moderneModalSectionTitleStyle,
              color: accentColor
            },
            children: "\u25B8 COMPOSANTS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalIngredientsContainerStyle,
            children: ingredients.map((ingredient, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                ...moderneModalIngredientStyle,
                borderColor: `${accentColor}44`
              },
              children: ingredient
            }, i))
          })]
        }), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...moderneModalSectionTitleStyle,
              color: priceColor
            },
            children: "\u25C8 TARIFS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: moderneModalPricesContainerStyle,
            children: prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...moderneModalPriceItemStyle,
                borderColor: price.id === product.default_price_id ? priceColor : `${priceColor}44`,
                boxShadow: price.id === product.default_price_id ? `0 0 15px ${priceColor}40` : 'none'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: priceColor,
                  fontFamily: 'monospace',
                  fontSize: '1.1rem'
                },
                children: formatPrice(price.price)
              }), price.id === product.default_price_id && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: '0.6rem',
                  color: priceColor,
                  letterSpacing: '0.1em'
                },
                children: "[DEFAULT]"
              })]
            }, i))
          })]
        }), (product.available_from || product.available_to || product.available_days?.length < 7) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: moderneModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...moderneModalSectionTitleStyle,
              color: primaryColor
            },
            children: "\u25F7 DISPONIBILIT\xC9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            style: {
              ...moderneModalAvailabilityStyle,
              color: 'rgba(255,255,255,0.7)'
            },
            children: [product.available_from && product.available_to && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: ["HEURES: ", product.available_from.slice(0, 5), " \u2192 ", product.available_to.slice(0, 5)]
            }), product.available_days && product.available_days.length < 7 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                display: 'block',
                marginTop: '0.25rem'
              },
              children: ["JOURS: ", ['DIM', 'LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM'].filter((_, i) => product.available_days.includes(i)).join(' · ')]
            })]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...moderneModalFooterStyle,
          borderColor: `${primaryColor}33`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor
          },
          children: "\u25E2\u25E4"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor,
            letterSpacing: '0.2em'
          },
          children: "DATA LOADED"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor
          },
          children: "\u25E5\u25E3"
        })]
      })]
    })]
  });
};

// Keyframes pour le modal Moderne
const moderneModalKeyframesCSS = `
    @keyframes moderneScanModal {
        0% { top: 0; }
        100% { top: 100%; }
    }
    @keyframes moderneFlickerModal {
        0%, 100% { opacity: 1; }
        92% { opacity: 1; }
        93% { opacity: 0.8; }
        94% { opacity: 1; }
    }
`;

// Styles pour le modal Moderne
const moderneOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.9)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  transition: 'opacity 0.3s ease',
  backdropFilter: 'blur(10px)'
};
const moderneOverlayScanLinesStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 240, 255, 0.02) 2px, rgba(0, 240, 255, 0.02) 4px)',
  pointerEvents: 'none'
};
const moderneModalContainerStyle = {
  position: 'relative',
  width: '90%',
  maxWidth: '600px',
  maxHeight: '90vh',
  overflow: 'auto',
  border: '1px solid rgba(0, 240, 255, 0.3)',
  transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  fontFamily: "'Orbitron', 'Rajdhani', 'Share Tech Mono', monospace"
};
const moderneModalCornerStyle = {
  position: 'absolute',
  width: '25px',
  height: '25px',
  borderWidth: '3px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 3,
  pointerEvents: 'none'
};
const moderneCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '40px',
  height: '40px',
  background: 'rgba(0, 0, 0, 0.8)',
  border: '1px solid',
  fontSize: '1.2rem',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.3s ease',
  fontFamily: 'inherit'
};
const moderneScanBarModalStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  height: '3px',
  animation: 'moderneScanModal 0.5s ease-out',
  zIndex: 20,
  pointerEvents: 'none'
};
const moderneModalImageContainerStyle = {
  position: 'relative',
  height: '250px',
  background: '#000',
  overflow: 'hidden'
};
const moderneModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const moderneModalHoloOverlayStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: 'none'
};
const moderneModalImageScanLinesStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'repeating-linear-gradient(0deg, transparent, transparent 1px, rgba(0, 0, 0, 0.2) 1px, rgba(0, 0, 0, 0.2) 2px)',
  pointerEvents: 'none'
};
const moderneModalImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  fontSize: '5rem',
  background: 'linear-gradient(135deg, #0a0a1e 0%, #1a1a3e 100%)'
};
const moderneModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  background: 'rgba(0, 0, 0, 0.8)',
  border: '1px solid',
  fontSize: '1rem',
  cursor: 'pointer',
  zIndex: 2,
  transition: 'all 0.3s ease'
};
const moderneModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px'
};
const moderneModalIndicatorStyle = {
  width: '30px',
  height: '4px',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const moderneModalBadgesStyle = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  display: 'flex',
  gap: '0.5rem',
  zIndex: 2
};
const moderneModalBadgeStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.7rem',
  fontWeight: '700',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: '#000'
};
const moderneModalMainPriceStyle = {
  position: 'absolute',
  bottom: '1rem',
  right: '1rem',
  padding: '0.6rem 1.2rem',
  fontSize: '1.4rem',
  fontWeight: '700',
  background: 'rgba(0, 0, 0, 0.9)',
  border: '2px solid',
  fontFamily: 'monospace',
  zIndex: 2
};
const moderneModalContentStyle = {
  padding: '1.5rem'
};
const moderneModalTitleStyle = {
  fontSize: '1.5rem',
  fontWeight: '700',
  margin: '0 0 0.5rem',
  letterSpacing: '0.15em'
};
const moderneModalDataLineStyle = {
  height: '2px',
  marginBottom: '1rem'
};
const moderneModalDescriptionStyle = {
  fontSize: '0.9rem',
  color: 'rgba(255,255,255,0.7)',
  margin: '0 0 1.5rem',
  lineHeight: 1.6
};
const moderneModalSectionStyle = {
  marginBottom: '1.25rem'
};
const moderneModalSectionTitleStyle = {
  fontSize: '0.8rem',
  fontWeight: '600',
  margin: '0 0 0.75rem',
  letterSpacing: '0.2em',
  textTransform: 'uppercase'
};
const moderneModalTagsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const moderneModalTagStyle = {
  padding: '0.3rem 0.7rem',
  fontSize: '0.75rem',
  border: '1px solid',
  fontFamily: 'monospace'
};
const moderneModalAllergensContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const moderneModalAllergenItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.4rem',
  padding: '0.4rem 0.8rem',
  border: '1px solid',
  fontSize: '0.75rem'
};
const moderneModalAllergenIconStyle = {
  fontSize: '0.9rem'
};
const moderneModalIngredientsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const moderneModalIngredientStyle = {
  padding: '0.25rem 0.6rem',
  fontSize: '0.75rem',
  color: 'rgba(255,255,255,0.6)',
  border: '1px solid'
};
const moderneModalPricesContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem'
};
const moderneModalPriceItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  padding: '0.75rem 1.25rem',
  border: '1px solid',
  background: 'rgba(0, 0, 0, 0.5)'
};
const moderneModalAvailabilityStyle = {
  fontSize: '0.85rem',
  margin: 0,
  letterSpacing: '0.1em',
  fontFamily: 'monospace'
};
const moderneModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5rem',
  padding: '1rem',
  borderTop: '1px solid',
  fontSize: '0.75rem'
};

// ============================================
// TEMPLATE PRESTIGE (Royal/Luxueux)
// ============================================
const ProductDetailModalPrestige = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);

  // Normaliser les propriétés (snake_case -> camelCase)
  const normalizedProps = normalizeStylesProperties(styles_properties);

  // Extraire les propriétés personnalisées
  const {
    primaryColor = '#d4af37',
    secondaryColor = '#1a1a2e',
    accentColor = '#8b0000',
    priceColor = '#d4af37',
    textColor = '#f5f5dc',
    cardBackground = 'linear-gradient(145deg, #1a1a2e 0%, #2d2d44 100%)'
  } = normalizedProps;
  (0, _react.useEffect)(() => {
    requestAnimationFrame(() => setIsVisible(true));
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const images = product.images || [];
  const prices = product.prices || [];
  const allergens = product.allergens || [];
  const ingredients = product.ingredients || [];
  const tags = product.tags || [];
  const getDefaultImage = () => {
    if (images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return images.indexOf(img);
    }
    return 0;
  };
  const getDefaultPrice = () => {
    if (prices.length === 0) return null;
    if (product.default_price_id) {
      const price = prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#228b22',
      'B': '#6b8e23',
      'C': '#daa520',
      'D': '#cd853f',
      'E': '#8b0000'
    };
    return colors[score] || primaryColor;
  };
  (0, _react.useEffect)(() => {
    const defaultIdx = getDefaultImage();
    if (defaultIdx !== null) setCurrentImageIndex(defaultIdx);
  }, [product]);
  const currentImage = images[currentImageIndex]?.image_url;
  const defaultPrice = getDefaultPrice();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      ...prestigeOverlayStyle,
      opacity: isVisible ? 1 : 0
    },
    onClick: handleClose,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: prestigeModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: prestigeOverlayPatternStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        ...prestigeModalContainerStyle,
        background: cardBackground,
        transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(50px) scale(0.95)',
        opacity: isVisible ? 1 : 0
      },
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeModalFrameStyle,
          top: 0,
          background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        style: {
          ...prestigeCloseButtonStyle,
          borderColor: primaryColor,
          color: primaryColor
        },
        onClick: handleClose,
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeModalCrownStyle,
          color: primaryColor
        },
        children: "\u265B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeModalImageContainerStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: prestigeModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalVignetteStyle
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...prestigeModalImagePlaceholderStyle,
            color: primaryColor
          },
          children: "\u269C"
        }), images.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...prestigeModalNavButtonStyle,
              left: '1rem',
              borderColor: primaryColor,
              color: primaryColor
            },
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            children: "\u276E"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            style: {
              ...prestigeModalNavButtonStyle,
              right: '1rem',
              borderColor: primaryColor,
              color: primaryColor
            },
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            children: "\u276F"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              style: {
                ...prestigeModalIndicatorStyle,
                background: i === currentImageIndex ? primaryColor : `${primaryColor}44`,
                transform: i === currentImageIndex ? 'rotate(45deg) scale(1.3)' : 'rotate(45deg)',
                boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none'
              },
              onClick: () => setCurrentImageIndex(i)
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...prestigeModalBadgeStyle,
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${accentColor} 100%)`
            },
            children: "\u2605 Signature"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...prestigeModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["Nutri-Score ", product.nutrition_score]
          })]
        }), defaultPrice !== null && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            ...prestigeModalMainPriceStyle,
            background: secondaryColor,
            borderColor: primaryColor,
            color: primaryColor
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '0.8rem',
              opacity: 0.7
            },
            children: "\u2726"
          }), formatPrice(defaultPrice), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '0.8rem',
              opacity: 0.7
            },
            children: "\u2726"
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: prestigeModalContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...prestigeModalFleurStyle,
            color: primaryColor
          },
          children: "\u269C"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          style: {
            ...prestigeModalTitleStyle,
            color: textColor
          },
          children: product.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...prestigeModalOrnamentStyle,
            color: primaryColor
          },
          children: "\u2500\u2500\u2500 \u2767 \u2500\u2500\u2500"
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...prestigeModalDescriptionStyle,
            color: `${textColor}99`
          },
          children: product.description
        }), tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...prestigeModalSectionTitleStyle,
              color: primaryColor
            },
            children: "\u2767 Caract\xE9ristiques"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalTagsContainerStyle,
            children: tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                ...prestigeModalTagStyle,
                borderColor: `${primaryColor}44`,
                color: primaryColor
              },
              children: tag
            }, i))
          })]
        }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...prestigeModalSectionTitleStyle,
              color: accentColor
            },
            children: "\u26A0 Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalAllergensContainerStyle,
            children: allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...prestigeModalAllergenItemStyle,
                borderColor: `${accentColor}44`
              },
              title: allergen.description || allergen,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: accentColor
                },
                children: allergen.icon || '⚠'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: accentColor
                },
                children: allergen.name || allergen
              })]
            }, i))
          })]
        }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...prestigeModalSectionTitleStyle,
              color: textColor
            },
            children: "\u2767 Composition"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalIngredientsContainerStyle,
            children: ingredients.map((ingredient, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                ...prestigeModalIngredientStyle,
                color: `${textColor}77`
              },
              children: ingredient
            }, i))
          })]
        }), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...prestigeModalSectionTitleStyle,
              color: priceColor
            },
            children: "\u2726 Tarifs"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: prestigeModalPricesContainerStyle,
            children: prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...prestigeModalPriceItemStyle,
                borderColor: price.id === product.default_price_id ? priceColor : `${priceColor}33`,
                boxShadow: price.id === product.default_price_id ? `0 0 15px ${priceColor}30` : 'none'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  color: priceColor,
                  fontSize: '1.1rem',
                  fontStyle: 'italic'
                },
                children: formatPrice(price.price)
              }), price.id === product.default_price_id && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  fontSize: '0.65rem',
                  color: priceColor,
                  fontStyle: 'italic'
                },
                children: "Recommand\xE9"
              })]
            }, i))
          })]
        }), (product.available_from || product.available_to || product.available_days?.length < 7) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: prestigeModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...prestigeModalSectionTitleStyle,
              color: textColor
            },
            children: "\u25F7 Disponibilit\xE9"
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
            style: {
              ...prestigeModalAvailabilityStyle,
              color: `${textColor}88`
            },
            children: [product.available_from && product.available_to && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              children: ["De ", product.available_from.slice(0, 5), " \xE0 ", product.available_to.slice(0, 5)]
            }), product.available_days && product.available_days.length < 7 && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                display: 'block',
                marginTop: '0.25rem'
              },
              children: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'].filter((_, i) => product.available_days.includes(i)).join(' • ')
            })]
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...prestigeModalFooterStyle,
          borderColor: `${primaryColor}33`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor
          },
          children: "\u269C"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: `${textColor}66`,
            letterSpacing: '0.2em',
            fontSize: '0.7rem',
            fontStyle: 'italic'
          },
          children: "Excellence & Tradition"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor
          },
          children: "\u269C"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...prestigeModalFrameStyle,
          bottom: 0,
          background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
        }
      })]
    })]
  });
};

// Keyframes pour le modal Prestige
const prestigeModalKeyframesCSS = `
    @keyframes prestigeModalFloat {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-3px); }
    }
`;

// Styles pour le modal Prestige
const prestigeOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.85)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  transition: 'opacity 0.4s ease',
  backdropFilter: 'blur(8px)'
};
const prestigeOverlayPatternStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4af37' fill-opacity='0.02'%3E%3Cpath d='M30 30l15-15v30l-15 15-15-15V15l15 15z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
  pointerEvents: 'none'
};
const prestigeModalContainerStyle = {
  position: 'relative',
  width: '90%',
  maxWidth: '600px',
  maxHeight: '90vh',
  overflow: 'auto',
  border: '1px solid rgba(212, 175, 55, 0.3)',
  transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
  fontFamily: "'Cormorant Garamond', 'Playfair Display', 'Times New Roman', serif"
};
const prestigeModalFrameStyle = {
  position: 'absolute',
  left: '15%',
  right: '15%',
  height: '2px',
  zIndex: 3,
  pointerEvents: 'none'
};
const prestigeCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '40px',
  height: '40px',
  background: 'rgba(0, 0, 0, 0.5)',
  border: '1px solid',
  fontSize: '1.2rem',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.3s ease',
  fontFamily: 'inherit'
};
const prestigeModalCrownStyle = {
  position: 'absolute',
  top: '0.5rem',
  left: '50%',
  transform: 'translateX(-50%)',
  fontSize: '1.5rem',
  zIndex: 10,
  animation: 'prestigeModalFloat 3s ease-in-out infinite'
};
const prestigeModalImageContainerStyle = {
  position: 'relative',
  height: '280px',
  background: '#0a0a14',
  overflow: 'hidden'
};
const prestigeModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const prestigeModalVignetteStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  boxShadow: 'inset 0 0 80px rgba(0, 0, 0, 0.6)',
  pointerEvents: 'none'
};
const prestigeModalImagePlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  fontSize: '5rem',
  background: 'linear-gradient(135deg, #0a0a14 0%, #1a1a2e 100%)'
};
const prestigeModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  background: 'rgba(0, 0, 0, 0.6)',
  border: '1px solid',
  fontSize: '1rem',
  cursor: 'pointer',
  zIndex: 2,
  transition: 'all 0.3s ease'
};
const prestigeModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '12px'
};
const prestigeModalIndicatorStyle = {
  width: '10px',
  height: '10px',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const prestigeModalBadgesStyle = {
  position: 'absolute',
  top: '2.5rem',
  left: '1rem',
  display: 'flex',
  gap: '0.5rem',
  zIndex: 2
};
const prestigeModalBadgeStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.7rem',
  fontWeight: '500',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  color: '#fff',
  fontStyle: 'italic'
};
const prestigeModalMainPriceStyle = {
  position: 'absolute',
  bottom: '1.5rem',
  right: '1.5rem',
  padding: '0.6rem 1.2rem',
  fontSize: '1.3rem',
  fontWeight: '400',
  border: '1px solid',
  display: 'flex',
  alignItems: 'center',
  gap: '0.6rem',
  zIndex: 2,
  fontStyle: 'italic'
};
const prestigeModalContentStyle = {
  padding: '2rem',
  textAlign: 'center'
};
const prestigeModalFleurStyle = {
  fontSize: '1.5rem',
  marginBottom: '0.5rem',
  opacity: 0.7
};
const prestigeModalTitleStyle = {
  fontSize: '1.8rem',
  fontWeight: '500',
  margin: '0 0 0.5rem',
  letterSpacing: '0.05em'
};
const prestigeModalOrnamentStyle = {
  fontSize: '0.9rem',
  marginBottom: '1rem',
  opacity: 0.6,
  letterSpacing: '0.3em'
};
const prestigeModalDescriptionStyle = {
  fontSize: '1rem',
  margin: '0 0 1.5rem',
  lineHeight: 1.8,
  fontStyle: 'italic'
};
const prestigeModalSectionStyle = {
  marginBottom: '1.5rem',
  textAlign: 'left'
};
const prestigeModalSectionTitleStyle = {
  fontSize: '0.9rem',
  fontWeight: '500',
  margin: '0 0 0.75rem',
  letterSpacing: '0.1em',
  fontStyle: 'italic'
};
const prestigeModalTagsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const prestigeModalTagStyle = {
  padding: '0.3rem 0.7rem',
  fontSize: '0.8rem',
  border: '1px solid',
  fontStyle: 'italic'
};
const prestigeModalAllergensContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const prestigeModalAllergenItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.4rem',
  padding: '0.4rem 0.8rem',
  border: '1px solid',
  fontSize: '0.8rem',
  fontStyle: 'italic'
};
const prestigeModalIngredientsContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem'
};
const prestigeModalIngredientStyle = {
  padding: '0.25rem 0',
  fontSize: '0.85rem',
  fontStyle: 'italic'
};
const prestigeModalPricesContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem'
};
const prestigeModalPriceItemStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.3rem',
  padding: '0.75rem 1.25rem',
  border: '1px solid',
  background: 'rgba(0, 0, 0, 0.3)'
};
const prestigeModalAvailabilityStyle = {
  fontSize: '0.9rem',
  margin: 0,
  fontStyle: 'italic'
};
const prestigeModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1.5rem',
  padding: '1.25rem',
  borderTop: '1px solid'
};

// ============================================
// TEMPLATE STREET (Urban/Street Food)
// ============================================
const ProductDetailModalStreet = ({
  product,
  onClose,
  uri_transformer,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [isClosing, setIsClosing] = (0, _react.useState)(false);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#ffcc00',
    secondaryColor = '#ff3333',
    accentColor = '#00cc66',
    backgroundColor = '#1a1a1a',
    textColor = '#ffffff',
    priceColor = '#ffcc00',
    cardBackground = 'rgba(30, 30, 30, 0.98)'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 250);
  };
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#00cc66',
      'B': '#99cc00',
      'C': '#ffcc00',
      'D': '#ff9933',
      'E': '#ff3333'
    };
    return colors[score] || primaryColor;
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  const dynamicOverlayStyle = {
    ...streetModalOverlayStyle,
    opacity: isClosing ? 0 : 1
  };
  const dynamicContainerStyle = {
    ...streetModalContainerStyle,
    background: cardBackground,
    borderColor: primaryColor,
    transform: isClosing ? 'scale(0.9) rotate(-5deg)' : 'scale(1) rotate(0deg)',
    opacity: isClosing ? 0 : 1
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: dynamicOverlayStyle,
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: streetModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleClose,
        style: {
          ...streetModalCloseButtonStyle,
          background: secondaryColor,
          boxShadow: `3px 3px 0 #000`
        },
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...streetModalStickerStyle,
          background: primaryColor,
          color: '#000'
        },
        children: "\uD83D\uDD25 HOT!"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetModalImageSectionStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: streetModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: streetModalImageOverlayStyle
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...streetModalPlaceholderStyle,
            color: primaryColor
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '5rem'
            },
            children: "\uD83C\uDF54"
          })
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              ...streetModalNavButtonStyle,
              left: '1rem',
              background: primaryColor
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              ...streetModalNavButtonStyle,
              right: '1rem',
              background: primaryColor
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: streetModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                ...streetModalIndicatorStyle,
                background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.4)',
                boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none'
              }
            }, i))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: streetModalContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: {
            ...streetModalTitleStyle,
            color: primaryColor,
            textShadow: `3px 3px 0 ${secondaryColor}`
          },
          children: product.name?.toUpperCase()
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: streetModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...streetModalBadgeStyle,
              background: secondaryColor
            },
            children: "\u2B50 BEST-SELLER"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...streetModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["NUTRI ", product.nutrition_score]
          })]
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...streetModalDescriptionStyle,
            color: `${textColor}cc`
          },
          children: product.description
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: streetModalTagsContainerStyle,
          children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...streetModalTagStyle,
              background: i % 2 === 0 ? `${primaryColor}33` : `${accentColor}33`,
              color: i % 2 === 0 ? primaryColor : accentColor
            },
            children: ["#", tag.toLowerCase().replace(/\s/g, '')]
          }, i))
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: streetModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...streetModalSectionTitleStyle,
              color: secondaryColor
            },
            children: "\u26A0\uFE0F ALLERG\xC8NES"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: streetModalAllergensStyle,
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                ...streetModalAllergenStyle,
                background: `${secondaryColor}22`,
                color: secondaryColor,
                borderColor: `${secondaryColor}44`
              },
              children: [allergen.icon || '⚠️', " ", allergen.name || allergen]
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: streetModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...streetModalSectionTitleStyle,
              color: accentColor
            },
            children: "\uD83D\uDCDD CE QU'IL Y A DEDANS"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              ...streetModalIngredientsStyle,
              color: `${textColor}99`
            },
            children: product.ingredients.join(' + ')
          })]
        }), product.prices?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: streetModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...streetModalSectionTitleStyle,
              color: primaryColor
            },
            children: "\uD83D\uDCB0 COMBIEN \xC7A CO\xDBTE"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: streetModalPricesStyle,
            children: product.prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...streetModalPriceItemStyle,
                background: i === 0 ? primaryColor : '#333',
                color: i === 0 ? '#000' : textColor,
                boxShadow: `4px 4px 0 ${i === 0 ? secondaryColor : '#000'}`
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: streetModalPriceLabelStyle,
                children: price.name || 'PRIX'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: streetModalPriceValueStyle,
                children: formatPrice(price.price)
              })]
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: streetModalAvailabilityStyle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...streetModalAvailabilityBadgeStyle,
              background: product.is_available !== false ? accentColor : secondaryColor
            },
            children: product.is_available !== false ? '✓ DISPO MAINTENANT!' : '✗ SOLD OUT BRO'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...streetModalFooterStyle,
          borderColor: `${primaryColor}44`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor,
            fontSize: '1.5rem'
          },
          children: "\uD83D\uDD25"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: `${textColor}77`,
            fontWeight: '700',
            letterSpacing: '0.2em',
            fontSize: '0.8rem'
          },
          children: "STREET FOOD VIBES"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor,
            fontSize: '1.5rem'
          },
          children: "\uD83D\uDD25"
        })]
      })]
    })]
  });
};

// Keyframes CSS pour le modal Street
const streetModalKeyframesCSS = `
    @keyframes streetModalSlideIn {
        from { 
            transform: scale(0.8) rotate(-10deg);
            opacity: 0;
        }
        to { 
            transform: scale(1) rotate(0deg);
            opacity: 1;
        }
    }
`;

// Styles du modal Street
const streetModalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.9)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  padding: '2rem',
  boxSizing: 'border-box',
  transition: 'opacity 0.25s ease'
};
const streetModalContainerStyle = {
  width: '100%',
  maxWidth: '600px',
  maxHeight: '90vh',
  background: 'rgba(30, 30, 30, 0.98)',
  border: '4px solid',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  animation: 'streetModalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
  transition: 'all 0.25s ease',
  fontFamily: "'Bebas Neue', 'Impact', 'Anton', sans-serif"
};
const streetModalCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '45px',
  height: '45px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.5rem',
  fontWeight: '900',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.2s ease'
};
const streetModalStickerStyle = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  padding: '0.5rem 1rem',
  fontSize: '0.8rem',
  fontWeight: '900',
  transform: 'rotate(-10deg)',
  zIndex: 10,
  boxShadow: '2px 2px 0 #000'
};
const streetModalImageSectionStyle = {
  position: 'relative',
  height: '300px',
  background: '#000',
  flexShrink: 0
};
const streetModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const streetModalImageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '50%',
  background: 'linear-gradient(to top, rgba(30, 30, 30, 1) 0%, transparent 100%)',
  pointerEvents: 'none'
};
const streetModalPlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: '#1a1a1a'
};
const streetModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  fontWeight: '900',
  color: '#000',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '2px 2px 0 #000',
  transition: 'all 0.2s ease'
};
const streetModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '8px',
  zIndex: 5
};
const streetModalIndicatorStyle = {
  width: '30px',
  height: '5px',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.2s ease'
};
const streetModalContentStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '1.5rem'
};
const streetModalTitleStyle = {
  fontSize: '2.5rem',
  fontWeight: '900',
  margin: '0 0 1rem',
  letterSpacing: '0.02em',
  lineHeight: 1.1
};
const streetModalBadgesStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginBottom: '1rem'
};
const streetModalBadgeStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.75rem',
  fontWeight: '900',
  color: '#fff',
  textTransform: 'uppercase',
  letterSpacing: '0.1em'
};
const streetModalDescriptionStyle = {
  fontSize: '1rem',
  lineHeight: 1.6,
  margin: '0 0 1.5rem',
  fontFamily: "'Inter', sans-serif",
  fontWeight: '400'
};
const streetModalTagsContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginBottom: '1.5rem'
};
const streetModalTagStyle = {
  padding: '0.35rem 0.75rem',
  fontSize: '0.8rem',
  fontWeight: '700'
};
const streetModalSectionStyle = {
  marginBottom: '1.5rem'
};
const streetModalSectionTitleStyle = {
  fontSize: '1.2rem',
  fontWeight: '900',
  margin: '0 0 0.75rem',
  letterSpacing: '0.05em',
  textTransform: 'uppercase'
};
const streetModalAllergensStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap'
};
const streetModalAllergenStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.8rem',
  fontWeight: '600',
  border: '2px solid'
};
const streetModalIngredientsStyle = {
  fontSize: '0.95rem',
  lineHeight: 1.6,
  margin: 0,
  fontFamily: "'Inter', sans-serif"
};
const streetModalPricesStyle = {
  display: 'flex',
  gap: '1rem',
  flexWrap: 'wrap'
};
const streetModalPriceItemStyle = {
  padding: '1rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  minWidth: '120px'
};
const streetModalPriceLabelStyle = {
  fontSize: '0.75rem',
  fontWeight: '600',
  textTransform: 'uppercase',
  letterSpacing: '0.1em',
  opacity: 0.8
};
const streetModalPriceValueStyle = {
  fontSize: '1.5rem',
  fontWeight: '900'
};
const streetModalAvailabilityStyle = {
  textAlign: 'center',
  marginTop: '1rem'
};
const streetModalAvailabilityBadgeStyle = {
  display: 'inline-block',
  padding: '0.6rem 1.5rem',
  fontSize: '1rem',
  fontWeight: '900',
  color: '#000',
  letterSpacing: '0.1em',
  boxShadow: '3px 3px 0 #000'
};
const streetModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  borderTop: '3px solid',
  flexShrink: 0
};

// ============================================
// TEMPLATE TROPICAL (Plage/Paradisiaque)
// ============================================
const ProductDetailModalTropical = ({
  product,
  onClose,
  uri_transformer,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [isClosing, setIsClosing] = (0, _react.useState)(false);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#00bcd4',
    secondaryColor = '#ff7043',
    accentColor = '#ffca28',
    backgroundColor = '#87CEEB',
    textColor = '#1a4a5e',
    priceColor = '#00897b',
    cardBackground = 'rgba(255, 255, 255, 0.98)'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#4caf50',
      'B': '#8bc34a',
      'C': '#ffca28',
      'D': '#ff9800',
      'E': '#f44336'
    };
    return colors[score] || primaryColor;
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  const dynamicOverlayStyle = {
    ...tropicalModalOverlayStyle,
    opacity: isClosing ? 0 : 1
  };
  const dynamicContainerStyle = {
    ...tropicalModalContainerStyle,
    background: cardBackground,
    transform: isClosing ? 'scale(0.9) translateY(50px)' : 'scale(1) translateY(0)',
    opacity: isClosing ? 0 : 1
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: dynamicOverlayStyle,
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: tropicalModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalModalDecoStyle,
        top: '5%',
        left: '5%',
        fontSize: '4rem'
      },
      children: "\uD83C\uDF34"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalModalDecoStyle,
        top: '10%',
        right: '8%',
        fontSize: '3rem'
      },
      children: "\uD83C\uDF3A"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalModalDecoStyle,
        bottom: '15%',
        left: '3%',
        fontSize: '3rem'
      },
      children: "\uD83C\uDF79"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...tropicalModalDecoStyle,
        bottom: '10%',
        right: '5%',
        fontSize: '3.5rem'
      },
      children: "\uD83E\uDD65"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleClose,
        style: {
          ...tropicalModalCloseButtonStyle,
          background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`
        },
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalModalImageSectionStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: tropicalModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: tropicalModalImageOverlayStyle
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...tropicalModalPlaceholderStyle,
            background: `linear-gradient(135deg, ${primaryColor}33, ${secondaryColor}33)`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '5rem'
            },
            children: "\uD83E\uDD65"
          })
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              ...tropicalModalNavButtonStyle,
              left: '1rem',
              background: 'rgba(255,255,255,0.9)'
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              ...tropicalModalNavButtonStyle,
              right: '1rem',
              background: 'rgba(255,255,255,0.9)'
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: tropicalModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                ...tropicalModalIndicatorStyle,
                background: i === currentImageIndex ? '#fff' : 'rgba(255,255,255,0.5)',
                transform: i === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
              }
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: tropicalModalSunStyle,
          children: "\u2600\uFE0F"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: tropicalModalContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: {
            ...tropicalModalTitleStyle,
            color: primaryColor
          },
          children: product.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: tropicalModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...tropicalModalBadgeStyle,
              background: `linear-gradient(135deg, ${secondaryColor}, ${accentColor})`
            },
            children: "\uD83C\uDF1F Favori"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...tropicalModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["Nutri-Score ", product.nutrition_score]
          })]
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...tropicalModalDescriptionStyle,
            color: `${textColor}cc`
          },
          children: product.description
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: tropicalModalTagsContainerStyle,
          children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...tropicalModalTagStyle,
              background: `${primaryColor}22`,
              color: primaryColor
            },
            children: tag
          }, i))
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: tropicalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...tropicalModalSectionTitleStyle,
              color: secondaryColor
            },
            children: "\u26A0\uFE0F Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: tropicalModalAllergensStyle,
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                ...tropicalModalAllergenStyle,
                background: `${secondaryColor}22`,
                color: secondaryColor
              },
              children: [allergen.icon || '⚠️', " ", allergen.name || allergen]
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: tropicalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...tropicalModalSectionTitleStyle,
              color: accentColor
            },
            children: "\uD83E\uDD57 Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              ...tropicalModalIngredientsStyle,
              color: `${textColor}aa`
            },
            children: product.ingredients.join(' • ')
          })]
        }), product.prices?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: tropicalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...tropicalModalSectionTitleStyle,
              color: priceColor
            },
            children: "\uD83D\uDCB0 Prix"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: tropicalModalPricesStyle,
            children: product.prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...tropicalModalPriceItemStyle,
                background: i === 0 ? `linear-gradient(135deg, ${priceColor}, ${primaryColor})` : 'rgba(0,0,0,0.05)',
                color: i === 0 ? '#fff' : textColor
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: tropicalModalPriceLabelStyle,
                children: price.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: tropicalModalPriceValueStyle,
                children: formatPrice(price.price)
              })]
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: tropicalModalAvailabilityStyle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...tropicalModalAvailabilityBadgeStyle,
              background: product.is_available !== false ? `linear-gradient(135deg, ${priceColor}, ${primaryColor})` : `linear-gradient(135deg, ${secondaryColor}, #f44336)`
            },
            children: product.is_available !== false ? '✓ Disponible' : '✗ Indisponible'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...tropicalModalFooterStyle,
          background: `linear-gradient(90deg, ${primaryColor}22, ${secondaryColor}22, ${accentColor}22)`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83C\uDF34"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: textColor,
            fontWeight: '500',
            letterSpacing: '0.1em',
            fontSize: '0.8rem'
          },
          children: "SAVEURS DU PARADIS"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83C\uDF34"
        })]
      })]
    })]
  });
};

// Keyframes CSS pour le modal Tropical
const tropicalModalKeyframesCSS = `
    @keyframes tropicalModalSlideIn {
        from { 
            transform: scale(0.9) translateY(50px);
            opacity: 0;
        }
        to { 
            transform: scale(1) translateY(0);
            opacity: 1;
        }
    }
    @keyframes tropicalModalFloat {
        0%, 100% { transform: translateY(0) rotate(0deg); }
        50% { transform: translateY(-10px) rotate(5deg); }
    }
`;

// Styles du modal Tropical
const tropicalModalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, rgba(135, 206, 235, 0.95) 0%, rgba(222, 184, 135, 0.95) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  padding: '2rem',
  boxSizing: 'border-box',
  transition: 'opacity 0.3s ease'
};
const tropicalModalDecoStyle = {
  position: 'absolute',
  opacity: 0.5,
  animation: 'tropicalModalFloat 4s ease-in-out infinite',
  pointerEvents: 'none'
};
const tropicalModalContainerStyle = {
  width: '100%',
  maxWidth: '550px',
  maxHeight: '90vh',
  background: 'rgba(255, 255, 255, 0.98)',
  borderRadius: '25px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  animation: 'tropicalModalSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  transition: 'all 0.3s ease',
  fontFamily: "'Poppins', 'Quicksand', sans-serif",
  boxShadow: '0 25px 80px rgba(0, 188, 212, 0.3)'
};
const tropicalModalCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '45px',
  height: '45px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.3rem',
  fontWeight: '600',
  color: '#fff',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 10,
  boxShadow: '0 4px 15px rgba(0, 188, 212, 0.4)',
  transition: 'all 0.3s ease'
};
const tropicalModalImageSectionStyle = {
  position: 'relative',
  height: '280px',
  flexShrink: 0,
  overflow: 'hidden'
};
const tropicalModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const tropicalModalImageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '40%',
  background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, transparent 100%)',
  pointerEvents: 'none'
};
const tropicalModalPlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};
const tropicalModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  color: '#1a4a5e',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
  transition: 'all 0.3s ease'
};
const tropicalModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1.5rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 5
};
const tropicalModalIndicatorStyle = {
  width: '10px',
  height: '10px',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
};
const tropicalModalSunStyle = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  fontSize: '2.5rem',
  animation: 'tropicalModalFloat 3s ease-in-out infinite'
};
const tropicalModalContentStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '1.5rem'
};
const tropicalModalTitleStyle = {
  fontSize: '2rem',
  fontWeight: '700',
  margin: '0 0 1rem',
  lineHeight: 1.2
};
const tropicalModalBadgesStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginBottom: '1rem'
};
const tropicalModalBadgeStyle = {
  padding: '0.4rem 0.9rem',
  fontSize: '0.8rem',
  fontWeight: '600',
  color: '#fff',
  borderRadius: '20px',
  boxShadow: '0 3px 10px rgba(0,0,0,0.15)'
};
const tropicalModalDescriptionStyle = {
  fontSize: '1rem',
  lineHeight: 1.7,
  margin: '0 0 1.5rem'
};
const tropicalModalTagsContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  marginBottom: '1.5rem'
};
const tropicalModalTagStyle = {
  padding: '0.35rem 0.8rem',
  fontSize: '0.8rem',
  fontWeight: '600',
  borderRadius: '15px'
};
const tropicalModalSectionStyle = {
  marginBottom: '1.5rem'
};
const tropicalModalSectionTitleStyle = {
  fontSize: '1.1rem',
  fontWeight: '600',
  margin: '0 0 0.75rem'
};
const tropicalModalAllergensStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap'
};
const tropicalModalAllergenStyle = {
  padding: '0.4rem 0.8rem',
  fontSize: '0.8rem',
  fontWeight: '500',
  borderRadius: '15px'
};
const tropicalModalIngredientsStyle = {
  fontSize: '0.95rem',
  lineHeight: 1.6,
  margin: 0,
  fontStyle: 'italic'
};
const tropicalModalPricesStyle = {
  display: 'flex',
  gap: '0.75rem',
  flexWrap: 'wrap'
};
const tropicalModalPriceItemStyle = {
  padding: '0.75rem 1.25rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  borderRadius: '15px',
  minWidth: '100px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
};
const tropicalModalPriceLabelStyle = {
  fontSize: '0.75rem',
  fontWeight: '500',
  opacity: 0.8
};
const tropicalModalPriceValueStyle = {
  fontSize: '1.3rem',
  fontWeight: '700'
};
const tropicalModalAvailabilityStyle = {
  textAlign: 'center',
  marginTop: '1rem'
};
const tropicalModalAvailabilityBadgeStyle = {
  display: 'inline-block',
  padding: '0.6rem 1.5rem',
  fontSize: '0.95rem',
  fontWeight: '600',
  color: '#fff',
  borderRadius: '25px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.15)'
};
const tropicalModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  borderRadius: '0 0 25px 25px',
  flexShrink: 0,
  fontSize: '1.5rem'
};

// ============================================
// TEMPLATE MEDIEVAL (Taverne/Château)
// ============================================
const ProductDetailModalMedieval = ({
  product,
  onClose,
  uri_transformer,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [isClosing, setIsClosing] = (0, _react.useState)(false);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#8b4513',
    secondaryColor = '#daa520',
    accentColor = '#8b0000',
    backgroundColor = '#3d2b1f',
    textColor = '#3d2b1f',
    priceColor = '#8b4513',
    cardBackground = '#f5e6c8'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#2e7d32',
      'B': '#558b2f',
      'C': '#f9a825',
      'D': '#ef6c00',
      'E': '#c62828'
    };
    return colors[score] || primaryColor;
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  const dynamicOverlayStyle = {
    ...medievalModalOverlayStyle,
    opacity: isClosing ? 0 : 1
  };
  const dynamicContainerStyle = {
    ...medievalModalContainerStyle,
    background: cardBackground,
    borderColor: primaryColor,
    transform: isClosing ? 'scale(0.9) translateY(30px)' : 'scale(1) translateY(0)',
    opacity: isClosing ? 0 : 1
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: dynamicOverlayStyle,
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: medievalModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalModalTorchStyle,
        left: '5%'
      },
      children: "\uD83D\uDD25"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...medievalModalTorchStyle,
        right: '5%'
      },
      children: "\uD83D\uDD25"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalModalBorderStyle,
          background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleClose,
        style: {
          ...medievalModalCloseButtonStyle,
          background: accentColor,
          borderColor: secondaryColor
        },
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalModalCornerStyle,
          top: '10px',
          left: '10px',
          color: secondaryColor
        },
        children: "\u269C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalModalCornerStyle,
          top: '10px',
          right: '10px',
          color: secondaryColor
        },
        children: "\u269C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalModalImageSectionStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: medievalModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: medievalModalImageOverlayStyle
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalModalPlaceholderStyle,
            color: secondaryColor
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '5rem'
            },
            children: "\uD83C\uDF56"
          })
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              ...medievalModalNavButtonStyle,
              left: '1rem',
              background: cardBackground,
              color: primaryColor,
              borderColor: primaryColor
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              ...medievalModalNavButtonStyle,
              right: '1rem',
              background: cardBackground,
              color: primaryColor,
              borderColor: primaryColor
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: medievalModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                ...medievalModalIndicatorStyle,
                background: i === currentImageIndex ? secondaryColor : `${secondaryColor}66`
              }
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalModalShieldStyle,
            color: secondaryColor
          },
          children: "\uD83D\uDEE1\uFE0F"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: medievalModalContentStyle,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalModalOrnamentStyle,
            color: primaryColor
          },
          children: "\u2550\u2550\u2550\u2550\u2550\u2550 \u2694\uFE0F \u2550\u2550\u2550\u2550\u2550\u2550"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: {
            ...medievalModalTitleStyle,
            color: secondaryColor,
            textShadow: `2px 2px 4px ${primaryColor}`
          },
          children: product.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: medievalModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...medievalModalBadgeStyle,
              background: accentColor
            },
            children: "\u2605 Sp\xE9cialit\xE9 du Ma\xEEtre"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...medievalModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["Nutri-Score ", product.nutrition_score]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...medievalModalDividerStyle,
            background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
          }
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...medievalModalDescriptionStyle,
            color: `${textColor}cc`
          },
          children: product.description
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: medievalModalTagsContainerStyle,
          children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...medievalModalTagStyle,
              background: `${primaryColor}22`,
              color: primaryColor,
              borderColor: `${primaryColor}44`
            },
            children: tag
          }, i))
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: medievalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...medievalModalSectionTitleStyle,
              color: accentColor
            },
            children: "\u26A0 Mise en garde"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: medievalModalAllergensStyle,
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                ...medievalModalAllergenStyle,
                background: `${accentColor}22`,
                color: accentColor,
                borderColor: `${accentColor}44`
              },
              children: [allergen.icon || '⚠', " ", allergen.name || allergen]
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: medievalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...medievalModalSectionTitleStyle,
              color: secondaryColor
            },
            children: "\uD83D\uDCDC Ingr\xE9dients de cette recette"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              ...medievalModalIngredientsStyle,
              color: `${textColor}aa`
            },
            children: product.ingredients.join(' • ')
          })]
        }), product.prices?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: medievalModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...medievalModalSectionTitleStyle,
              color: priceColor
            },
            children: "\uD83D\uDCB0 \xC9cus requis"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: medievalModalPricesStyle,
            children: product.prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...medievalModalPriceItemStyle,
                background: i === 0 ? `linear-gradient(135deg, ${priceColor}, ${secondaryColor})` : cardBackground,
                color: i === 0 ? '#fff' : textColor,
                borderColor: i === 0 ? secondaryColor : primaryColor
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: medievalModalPriceLabelStyle,
                children: price.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: medievalModalPriceValueStyle,
                children: formatPrice(price.price)
              })]
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: medievalModalAvailabilityStyle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...medievalModalAvailabilityBadgeStyle,
              background: product.is_available !== false ? `linear-gradient(135deg, #2e7d32, #4caf50)` : `linear-gradient(135deg, ${accentColor}, #c62828)`
            },
            children: product.is_available !== false ? '⚔️ Prêt à servir' : '🚫 Épuisé'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...medievalModalFooterStyle,
          borderColor: primaryColor
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor
          },
          children: "\u2694\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor,
            fontWeight: '600',
            letterSpacing: '0.1em',
            fontSize: '0.8rem'
          },
          children: "FESTOYEZ BRAVES GENS"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: secondaryColor
          },
          children: "\u2694\uFE0F"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...medievalModalBorderStyle,
          background: `linear-gradient(90deg, transparent, ${secondaryColor}, transparent)`
        }
      })]
    })]
  });
};

// Keyframes CSS pour le modal Medieval
const medievalModalKeyframesCSS = `
    @keyframes medievalModalSlideIn {
        from { 
            transform: scale(0.9) translateY(30px);
            opacity: 0;
        }
        to { 
            transform: scale(1) translateY(0);
            opacity: 1;
        }
    }
    @keyframes medievalModalFlicker {
        0%, 100% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.8; transform: scale(1.1); }
    }
`;

// Styles du modal Medieval
const medievalModalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, rgba(61, 43, 31, 0.95) 0%, rgba(74, 55, 40, 0.95) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  padding: '2rem',
  boxSizing: 'border-box',
  transition: 'opacity 0.3s ease'
};
const medievalModalTorchStyle = {
  position: 'absolute',
  top: '20%',
  fontSize: '3rem',
  animation: 'medievalModalFlicker 0.5s infinite',
  filter: 'drop-shadow(0 0 15px #ff6600)'
};
const medievalModalContainerStyle = {
  width: '100%',
  maxWidth: '550px',
  maxHeight: '90vh',
  background: '#f5e6c8',
  border: '4px solid',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  animation: 'medievalModalSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  transition: 'all 0.3s ease',
  fontFamily: "'MedievalSharp', 'Cinzel', Georgia, serif",
  boxShadow: '0 25px 80px rgba(0, 0, 0, 0.5)'
};
const medievalModalBorderStyle = {
  height: '4px',
  flexShrink: 0
};
const medievalModalCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  fontWeight: '600',
  color: '#fff',
  border: '2px solid',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.3s ease'
};
const medievalModalCornerStyle = {
  position: 'absolute',
  fontSize: '1.5rem',
  zIndex: 10
};
const medievalModalImageSectionStyle = {
  position: 'relative',
  height: '260px',
  flexShrink: 0,
  overflow: 'hidden',
  background: '#e6d5b8'
};
const medievalModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  filter: 'sepia(15%)'
};
const medievalModalImageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '40%',
  background: 'linear-gradient(to top, #f5e6c8 0%, transparent 100%)',
  pointerEvents: 'none'
};
const medievalModalPlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  background: 'linear-gradient(135deg, #e6d5b8, #f5e6c8)'
};
const medievalModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  border: '2px solid',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const medievalModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1.5rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 5
};
const medievalModalIndicatorStyle = {
  width: '10px',
  height: '10px',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const medievalModalShieldStyle = {
  position: 'absolute',
  top: '1rem',
  left: '1rem',
  fontSize: '2.5rem'
};
const medievalModalContentStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '1.5rem',
  textAlign: 'center'
};
const medievalModalOrnamentStyle = {
  fontSize: '0.85rem',
  letterSpacing: '0.2em',
  marginBottom: '0.5rem'
};
const medievalModalTitleStyle = {
  fontSize: '2rem',
  fontWeight: '400',
  margin: '0 0 0.75rem',
  letterSpacing: '0.05em'
};
const medievalModalBadgesStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '0.75rem'
};
const medievalModalBadgeStyle = {
  padding: '0.35rem 0.8rem',
  fontSize: '0.75rem',
  fontWeight: '500',
  color: '#fff',
  fontStyle: 'italic'
};
const medievalModalDividerStyle = {
  height: '2px',
  width: '100px',
  margin: '0 auto 1rem'
};
const medievalModalDescriptionStyle = {
  fontSize: '1rem',
  lineHeight: 1.7,
  margin: '0 0 1.5rem',
  fontStyle: 'italic'
};
const medievalModalTagsContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '1.5rem'
};
const medievalModalTagStyle = {
  padding: '0.3rem 0.7rem',
  fontSize: '0.8rem',
  fontWeight: '500',
  border: '1px solid'
};
const medievalModalSectionStyle = {
  marginBottom: '1.5rem'
};
const medievalModalSectionTitleStyle = {
  fontSize: '1.1rem',
  fontWeight: '500',
  margin: '0 0 0.75rem'
};
const medievalModalAllergensStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center'
};
const medievalModalAllergenStyle = {
  padding: '0.35rem 0.75rem',
  fontSize: '0.8rem',
  fontWeight: '500',
  border: '1px solid'
};
const medievalModalIngredientsStyle = {
  fontSize: '0.95rem',
  lineHeight: 1.6,
  margin: 0,
  fontStyle: 'italic'
};
const medievalModalPricesStyle = {
  display: 'flex',
  gap: '0.75rem',
  flexWrap: 'wrap',
  justifyContent: 'center'
};
const medievalModalPriceItemStyle = {
  padding: '0.75rem 1.25rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.25rem',
  border: '2px solid',
  minWidth: '100px'
};
const medievalModalPriceLabelStyle = {
  fontSize: '0.75rem',
  fontWeight: '500',
  opacity: 0.8
};
const medievalModalPriceValueStyle = {
  fontSize: '1.3rem',
  fontWeight: '600'
};
const medievalModalAvailabilityStyle = {
  textAlign: 'center',
  marginTop: '1rem'
};
const medievalModalAvailabilityBadgeStyle = {
  display: 'inline-block',
  padding: '0.6rem 1.5rem',
  fontSize: '0.95rem',
  fontWeight: '500',
  color: '#fff'
};
const medievalModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  borderTop: '3px solid',
  flexShrink: 0
};

// ============================================
// TEMPLATE LIGHT (Performance optimisée)
// ============================================
// Modal ultra-léger :
// - Pas d'animations
// - Pas de gradients
// - Pas d'effets visuels lourds
// - Structure DOM minimale
// - Styles inline simples

const ProductDetailModalLight = ({
  product,
  onClose,
  uri_transformer,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#2563eb',
    secondaryColor = '#64748b',
    accentColor = '#10b981',
    textColor = '#1e293b',
    priceColor = '#10b981',
    cardBackground = '#ffffff'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#22c55e',
      'B': '#84cc16',
      'C': '#eab308',
      'D': '#f97316',
      'E': '#ef4444'
    };
    return colors[score] || secondaryColor;
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '1rem',
      boxSizing: 'border-box'
    },
    onClick: handleBackdropClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        width: '100%',
        maxWidth: '500px',
        maxHeight: '90vh',
        background: cardBackground,
        borderRadius: '8px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0.75rem 1rem',
          borderBottom: '1px solid #e2e8f0'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.75rem',
            color: secondaryColor
          },
          children: "D\xE9tail produit"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: onClose,
          style: {
            width: '28px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem',
            color: secondaryColor,
            background: '#f1f5f9',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          },
          children: "\u2715"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          position: 'relative',
          height: '220px',
          background: '#f1f5f9',
          flexShrink: 0
        },
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            fontSize: '3rem',
            opacity: 0.3
          },
          children: "\uD83C\uDF7D\uFE0F"
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              position: 'absolute',
              left: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '32px',
              height: '32px',
              background: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.9rem'
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              position: 'absolute',
              right: '0.5rem',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '32px',
              height: '32px',
              background: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.9rem'
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: '0.5rem',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '6px'
            },
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                width: '8px',
                height: '8px',
                background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.6)',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                padding: 0
              }
            }, i))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          flex: 1,
          overflowY: 'auto',
          padding: '1rem'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '0.75rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            style: {
              fontSize: '1.25rem',
              fontWeight: '600',
              margin: '0 0 0.5rem',
              color: textColor
            },
            children: product.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              gap: '0.5rem',
              flexWrap: 'wrap'
            },
            children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.2rem 0.5rem',
                fontSize: '0.7rem',
                fontWeight: '600',
                background: accentColor,
                color: '#fff',
                borderRadius: '3px'
              },
              children: "\u2605 Recommand\xE9"
            }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                padding: '0.2rem 0.5rem',
                fontSize: '0.7rem',
                fontWeight: '600',
                background: getNutriScoreColor(product.nutrition_score),
                color: '#fff',
                borderRadius: '3px'
              },
              children: ["Nutri ", product.nutrition_score]
            })]
          })]
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            fontSize: '0.875rem',
            color: secondaryColor,
            lineHeight: 1.6,
            margin: '0 0 1rem'
          },
          children: product.description
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.75rem',
              fontWeight: '600',
              color: textColor,
              marginBottom: '0.35rem'
            },
            children: "Tags"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.35rem',
              flexWrap: 'wrap'
            },
            children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.15rem 0.4rem',
                fontSize: '0.7rem',
                background: '#f1f5f9',
                color: secondaryColor,
                borderRadius: '3px'
              },
              children: tag
            }, i))
          })]
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.75rem',
              fontWeight: '600',
              color: '#dc2626',
              marginBottom: '0.35rem'
            },
            children: "\u26A0 Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.35rem',
              flexWrap: 'wrap'
            },
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.15rem 0.4rem',
                fontSize: '0.7rem',
                background: '#fef2f2',
                color: '#dc2626',
                borderRadius: '3px'
              },
              children: allergen.name || allergen
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.75rem',
              fontWeight: '600',
              color: textColor,
              marginBottom: '0.35rem'
            },
            children: "Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.8rem',
              color: secondaryColor,
              margin: 0,
              lineHeight: 1.5
            },
            children: product.ingredients.join(' • ')
          })]
        }), product.prices?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.75rem',
              fontWeight: '600',
              color: textColor,
              marginBottom: '0.35rem'
            },
            children: "Prix"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.5rem',
              flexWrap: 'wrap'
            },
            children: product.prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                padding: '0.5rem 0.75rem',
                background: i === 0 ? priceColor : '#f1f5f9',
                color: i === 0 ? '#fff' : textColor,
                borderRadius: '4px',
                textAlign: 'center'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '0.65rem',
                  opacity: 0.8
                },
                children: price.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '1rem',
                  fontWeight: '700'
                },
                children: formatPrice(price.price)
              })]
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            padding: '0.5rem',
            background: product.is_available !== false ? '#f0fdf4' : '#fef2f2',
            color: product.is_available !== false ? '#16a34a' : '#dc2626',
            borderRadius: '4px',
            textAlign: 'center',
            fontSize: '0.85rem',
            fontWeight: '500'
          },
          children: product.is_available !== false ? '✓ Disponible' : '✗ Indisponible'
        })]
      })]
    })
  });
};

// ============================================
// TEMPLATE FRITERIE (Baraque à frites belge)
// ============================================
const ProductDetailModalFriterie = ({
  product,
  onClose,
  uri_transformer,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const [isClosing, setIsClosing] = (0, _react.useState)(false);
  const [steamBubbles, setSteamBubbles] = (0, _react.useState)([]);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#f4a020',
    // Jaune frite doré
    secondaryColor = '#c41e3a',
    // Rouge ketchup
    accentColor = '#8b4513',
    // Brun sauce
    backgroundColor = '#1a0f0a',
    // Brun foncé chaleureux
    textColor = '#fff8e7',
    // Blanc crème
    priceColor = '#f4a020',
    cardBackground = 'linear-gradient(180deg, #2a1a12 0%, #1a0f0a 100%)'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Effet de vapeur aléatoire
  (0, _react.useEffect)(() => {
    const interval = setInterval(() => {
      setSteamBubbles(prev => {
        const newBubbles = [...prev.filter(b => Date.now() - b.created < 2000)];
        if (newBubbles.length < 5 && Math.random() > 0.5) {
          newBubbles.push({
            id: Date.now(),
            created: Date.now(),
            left: 20 + Math.random() * 60,
            delay: Math.random() * 0.5
          });
        }
        return newBubbles;
      });
    }, 400);
    return () => clearInterval(interval);
  }, []);
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-BE', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85bb2f',
      'C': '#fecb02',
      'D': '#ee8100',
      'E': '#e63e11'
    };
    return colors[score?.toUpperCase()] || '#999';
  };

  // Emoji selon le type de produit
  const getProductEmoji = () => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('frite') || name.includes('frit')) return '🍟';
    if (name.includes('burger') || name.includes('hamburger')) return '🍔';
    if (name.includes('sauce')) return '🥫';
    if (name.includes('bière') || name.includes('beer')) return '🍺';
    if (name.includes('soda') || name.includes('coca') || name.includes('boisson')) return '🥤';
    if (name.includes('glace') || name.includes('ice')) return '🍦';
    if (name.includes('poulet') || name.includes('chicken') || name.includes('nugget')) return '🍗';
    if (name.includes('saucisse') || name.includes('fricadelle') || name.includes('cervela') || name.includes('boulet')) return '🌭';
    if (name.includes('fish') || name.includes('poisson')) return '🐟';
    if (name.includes('steak') || name.includes('viande')) return '🥩';
    if (name.includes('salade')) return '🥗';
    return '🍴';
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  const dynamicOverlayStyle = {
    ...friterieModalOverlayStyle,
    opacity: isClosing ? 0 : 1
  };
  const dynamicContainerStyle = {
    ...friterieModalContainerStyle,
    background: cardBackground,
    borderColor: primaryColor,
    transform: isClosing ? 'scale(0.9) rotate(-3deg)' : 'scale(1) rotate(0deg)',
    opacity: isClosing ? 0 : 1
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: dynamicOverlayStyle,
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: friterieModalKeyframesCSS
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...friterieModalDecoStyle,
        top: '8%',
        left: '5%',
        transform: 'rotate(-20deg)',
        fontSize: '3rem'
      },
      children: "\uD83C\uDF5F"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...friterieModalDecoStyle,
        top: '15%',
        right: '6%',
        transform: 'rotate(15deg)',
        fontSize: '2.5rem'
      },
      children: "\uD83C\uDF54"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...friterieModalDecoStyle,
        bottom: '12%',
        left: '4%',
        transform: 'rotate(10deg)',
        fontSize: '2.5rem'
      },
      children: "\uD83C\uDF2D"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        ...friterieModalDecoStyle,
        bottom: '8%',
        right: '5%',
        transform: 'rotate(-15deg)',
        fontSize: '3rem'
      },
      children: "\uD83C\uDF5F"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: dynamicContainerStyle,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...friterieModalCornerStyle,
          top: '8px',
          left: '8px',
          borderTopColor: primaryColor,
          borderLeftColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...friterieModalCornerStyle,
          top: '8px',
          right: '8px',
          borderTopColor: primaryColor,
          borderRightColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...friterieModalCornerStyle,
          bottom: '8px',
          left: '8px',
          borderBottomColor: primaryColor,
          borderLeftColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...friterieModalCornerStyle,
          bottom: '8px',
          right: '8px',
          borderBottomColor: primaryColor,
          borderRightColor: primaryColor
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleClose,
        style: {
          ...friterieModalCloseButtonStyle,
          background: secondaryColor,
          boxShadow: `0 4px 0 #8a1428, 0 6px 20px ${secondaryColor}50`
        },
        children: "\u2715"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          ...friterieModalEmojiBadgeStyle,
          background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
          boxShadow: `0 0 20px ${primaryColor}60, 0 4px 0 ${accentColor}`
        },
        children: getProductEmoji()
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: friterieModalImageSectionStyle,
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: uri_transformer(currentImage),
            alt: product.name,
            style: friterieModalImageStyle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              ...friterieModalImageOverlayStyle,
              background: `linear-gradient(to top, ${backgroundColor} 0%, transparent 60%)`
            }
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...friterieModalPlaceholderStyle,
            background: `linear-gradient(135deg, ${accentColor}30 0%, ${backgroundColor} 100%)`,
            color: primaryColor
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '5rem'
            },
            children: getProductEmoji()
          })
        }), steamBubbles.map(bubble => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            bottom: '30%',
            left: `${bubble.left}%`,
            width: '8px',
            height: '8px',
            background: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '50%',
            animation: `friterieBubble 2s ease-out ${bubble.delay}s`,
            pointerEvents: 'none'
          }
        }, bubble.id)), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              ...friterieModalNavButtonStyle,
              left: '1rem',
              background: primaryColor,
              boxShadow: `0 3px 0 ${accentColor}`
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              ...friterieModalNavButtonStyle,
              right: '1rem',
              background: primaryColor,
              boxShadow: `0 3px 0 ${accentColor}`
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: friterieModalIndicatorsStyle,
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                ...friterieModalIndicatorStyle,
                background: i === currentImageIndex ? primaryColor : 'rgba(255,255,255,0.4)',
                boxShadow: i === currentImageIndex ? `0 0 10px ${primaryColor}` : 'none',
                transform: i === currentImageIndex ? 'scale(1.3)' : 'scale(1)'
              }
            }, i))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...friterieModalContentStyle,
          color: textColor
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          style: {
            ...friterieModalTitleStyle,
            color: primaryColor,
            textShadow: `
                            0 0 10px ${primaryColor},
                            0 0 20px ${primaryColor}80,
                            0 0 30px ${secondaryColor}40
                        `
          },
          children: product.name
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: friterieModalBadgesStyle,
          children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...friterieModalBadgeStyle,
              background: `linear-gradient(135deg, ${secondaryColor}, #ff4757)`,
              boxShadow: `0 3px 0 #8a1428`
            },
            children: "\u2B50 Sp\xE9cialit\xE9 maison"
          }), product.nutrition_score && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            style: {
              ...friterieModalBadgeStyle,
              background: getNutriScoreColor(product.nutrition_score)
            },
            children: ["Nutri-Score ", product.nutrition_score]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            ...friterieModalDividerStyle,
            background: `linear-gradient(90deg, transparent, ${primaryColor}, transparent)`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              background: backgroundColor,
              padding: '0 1rem'
            },
            children: "\uD83C\uDF5F"
          })
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            ...friterieModalDescriptionStyle,
            color: `${textColor}cc`
          },
          children: product.description
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: friterieModalTagsContainerStyle,
          children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...friterieModalTagStyle,
              background: i % 2 === 0 ? `${primaryColor}33` : `${secondaryColor}33`,
              color: i % 2 === 0 ? primaryColor : secondaryColor,
              borderColor: i % 2 === 0 ? `${primaryColor}66` : `${secondaryColor}66`
            },
            children: tag
          }, i))
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: friterieModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...friterieModalSectionTitleStyle,
              color: secondaryColor
            },
            children: "\u26A0\uFE0F Attention aux allergies !"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: friterieModalAllergensStyle,
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                ...friterieModalAllergenStyle,
                background: `${secondaryColor}22`,
                color: secondaryColor,
                borderColor: `${secondaryColor}44`
              },
              children: [allergen.icon || '⚠️', " ", allergen.name || allergen]
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: friterieModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...friterieModalSectionTitleStyle,
              color: primaryColor
            },
            children: "\uD83D\uDCDD Ce qu'il y a dedans"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              ...friterieModalIngredientsStyle,
              color: `${textColor}aa`
            },
            children: product.ingredients.join(' • ')
          })]
        }), product.prices?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: friterieModalSectionStyle,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
            style: {
              ...friterieModalSectionTitleStyle,
              color: priceColor
            },
            children: "\uD83D\uDCB0 Combien \xE7a co\xFBte ?"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: friterieModalPricesStyle,
            children: product.prices.map((price, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                ...friterieModalPriceItemStyle,
                background: i === 0 ? `linear-gradient(135deg, ${priceColor}, ${secondaryColor})` : `${accentColor}33`,
                color: i === 0 ? '#fff' : textColor,
                boxShadow: i === 0 ? `0 4px 0 ${accentColor}` : 'none',
                borderColor: i === 0 ? 'transparent' : `${accentColor}66`
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: friterieModalPriceLabelStyle,
                children: price.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: friterieModalPriceValueStyle,
                children: formatPrice(price.price)
              })]
            }, i))
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: friterieModalAvailabilityStyle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              ...friterieModalAvailabilityBadgeStyle,
              background: product.is_available !== false ? `linear-gradient(135deg, #22c55e, #16a34a)` : `linear-gradient(135deg, ${secondaryColor}, #dc2626)`,
              boxShadow: product.is_available !== false ? '0 4px 0 #15803d' : '0 4px 0 #991b1b'
            },
            children: product.is_available !== false ? '🍟 Dispo maintenant !' : '😢 Désolé, y en a plus !'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          ...friterieModalFooterStyle,
          background: `linear-gradient(90deg, ${accentColor}22, ${backgroundColor}, ${accentColor}22)`,
          borderColor: `${primaryColor}33`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor,
            fontSize: '1.3rem'
          },
          children: "\uD83C\uDF5F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: `${textColor}88`,
            fontFamily: "'Georgia', serif",
            fontStyle: 'italic',
            fontSize: '0.85rem'
          },
          children: "Faites avec \u2764\uFE0F et de la bonne graisse !"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            color: primaryColor,
            fontSize: '1.3rem'
          },
          children: "\uD83C\uDF5F"
        })]
      })]
    })]
  });
};

// Keyframes CSS pour le modal Friterie
const friterieModalKeyframesCSS = `
    @keyframes friterieModalSlideIn {
        from { 
            transform: scale(0.8) rotate(-5deg);
            opacity: 0;
        }
        to { 
            transform: scale(1) rotate(0deg);
            opacity: 1;
        }
    }
    @keyframes friterieModalFloat {
        0%, 100% { transform: translateY(0) rotate(var(--rotation, 0deg)); }
        50% { transform: translateY(-8px) rotate(var(--rotation, 0deg)); }
    }
    @keyframes friterieBubble {
        0% { transform: translateY(0) scale(1); opacity: 0.6; }
        50% { transform: translateY(-20px) scale(1.3); opacity: 0.8; }
        100% { transform: translateY(-40px) scale(0.6); opacity: 0; }
    }
    @keyframes friterieGlow {
        0%, 100% { box-shadow: 0 0 15px currentColor; }
        50% { box-shadow: 0 0 25px currentColor, 0 0 40px currentColor; }
    }
    @keyframes friteriePulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }
`;

// Styles du modal Friterie
const friterieModalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'radial-gradient(ellipse at center, rgba(26, 15, 10, 0.95) 0%, rgba(10, 5, 2, 0.98) 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 10000,
  padding: '2rem',
  boxSizing: 'border-box',
  transition: 'opacity 0.3s ease'
};
const friterieModalDecoStyle = {
  position: 'absolute',
  opacity: 0.15,
  animation: 'friterieModalFloat 4s ease-in-out infinite',
  pointerEvents: 'none'
};
const friterieModalContainerStyle = {
  width: '100%',
  maxWidth: '550px',
  maxHeight: '90vh',
  border: '4px solid',
  borderRadius: '20px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  animation: 'friterieModalSlideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
  transition: 'all 0.3s ease',
  fontFamily: "'Fredoka One', 'Comic Sans MS', cursive",
  boxShadow: '0 0 30px rgba(244, 160, 32, 0.3), 0 25px 60px rgba(0, 0, 0, 0.5)'
};
const friterieModalCornerStyle = {
  position: 'absolute',
  width: '20px',
  height: '20px',
  borderWidth: '3px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 3,
  pointerEvents: 'none'
};
const friterieModalCloseButtonStyle = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  width: '45px',
  height: '45px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.4rem',
  fontWeight: '700',
  color: '#fff',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  zIndex: 10,
  transition: 'all 0.2s ease'
};
const friterieModalEmojiBadgeStyle = {
  position: 'absolute',
  top: '0.75rem',
  left: '1rem',
  width: '50px',
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.8rem',
  borderRadius: '50%',
  zIndex: 10,
  animation: 'friteriePulse 2s ease-in-out infinite'
};
const friterieModalImageSectionStyle = {
  position: 'relative',
  height: '260px',
  flexShrink: 0,
  overflow: 'hidden',
  background: '#0d0705'
};
const friterieModalImageStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover'
};
const friterieModalImageOverlayStyle = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: '50%',
  pointerEvents: 'none'
};
const friterieModalPlaceholderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%'
};
const friterieModalNavButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1rem',
  fontWeight: '900',
  color: '#1a0f0a',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'all 0.2s ease'
};
const friterieModalIndicatorsStyle = {
  position: 'absolute',
  bottom: '1rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  gap: '10px',
  zIndex: 5
};
const friterieModalIndicatorStyle = {
  width: '12px',
  height: '12px',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'all 0.3s ease'
};
const friterieModalContentStyle = {
  flex: 1,
  overflowY: 'auto',
  padding: '1.5rem'
};
const friterieModalTitleStyle = {
  fontSize: '1.8rem',
  fontWeight: '400',
  margin: '0 0 0.75rem',
  textAlign: 'center',
  letterSpacing: '1px'
};
const friterieModalBadgesStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '1rem'
};
const friterieModalBadgeStyle = {
  padding: '0.4rem 0.9rem',
  fontSize: '0.8rem',
  fontWeight: '400',
  color: '#fff',
  borderRadius: '20px'
};
const friterieModalDividerStyle = {
  height: '2px',
  margin: '0 0 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};
const friterieModalDescriptionStyle = {
  fontSize: '1rem',
  lineHeight: 1.7,
  margin: '0 0 1.25rem',
  textAlign: 'center',
  fontFamily: "'Georgia', serif",
  fontStyle: 'italic'
};
const friterieModalTagsContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '1.25rem'
};
const friterieModalTagStyle = {
  padding: '0.35rem 0.75rem',
  fontSize: '0.8rem',
  fontWeight: '400',
  borderRadius: '15px',
  border: '1px solid'
};
const friterieModalSectionStyle = {
  marginBottom: '1.25rem'
};
const friterieModalSectionTitleStyle = {
  fontSize: '1rem',
  fontWeight: '400',
  margin: '0 0 0.6rem',
  textAlign: 'center'
};
const friterieModalAllergensStyle = {
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap',
  justifyContent: 'center'
};
const friterieModalAllergenStyle = {
  padding: '0.35rem 0.7rem',
  fontSize: '0.8rem',
  fontWeight: '400',
  borderRadius: '12px',
  border: '1px solid'
};
const friterieModalIngredientsStyle = {
  fontSize: '0.9rem',
  lineHeight: 1.6,
  margin: 0,
  textAlign: 'center',
  fontFamily: "'Georgia', serif"
};
const friterieModalPricesStyle = {
  display: 'flex',
  gap: '0.75rem',
  flexWrap: 'wrap',
  justifyContent: 'center'
};
const friterieModalPriceItemStyle = {
  padding: '0.75rem 1.25rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.2rem',
  borderRadius: '15px',
  minWidth: '100px',
  border: '2px solid'
};
const friterieModalPriceLabelStyle = {
  fontSize: '0.7rem',
  fontWeight: '400',
  opacity: 0.85,
  textTransform: 'uppercase',
  letterSpacing: '0.05em'
};
const friterieModalPriceValueStyle = {
  fontSize: '1.4rem',
  fontWeight: '400'
};
const friterieModalAvailabilityStyle = {
  textAlign: 'center',
  marginTop: '1rem'
};
const friterieModalAvailabilityBadgeStyle = {
  display: 'inline-block',
  padding: '0.7rem 1.5rem',
  fontSize: '1rem',
  fontWeight: '400',
  color: '#fff',
  borderRadius: '25px'
};
const friterieModalFooterStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '1rem',
  borderTop: '2px solid',
  flexShrink: 0
};

// ============================================
// TEMPLATE PIZZERIA - Pizzeria Italienne
// ============================================
const ProductDetailModalPizzeria = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#c41e3a',
    secondaryColor = '#1a5f1a',
    accentColor = '#f4a020',
    backgroundColor = '#1a0a05',
    textColor = '#fff8e7',
    priceColor = '#f4a020'
  } = normalizedProps;
  (0, _react.useEffect)(() => {
    requestAnimationFrame(() => setIsVisible(true));
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };
  const images = product.images || [];
  const prices = product.prices || [];
  const allergens = product.allergens || [];
  const ingredients = product.ingredients || [];
  const tags = product.tags || [];
  const getDefaultImage = () => {
    if (images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return images.indexOf(img);
    }
    return 0;
  };
  const getDefaultPrice = () => {
    if (product.price !== undefined) return product.price;
    if (prices.length === 0) return null;
    if (product.default_price_id) {
      const price = prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return prices[0]?.price;
  };
  const formatPrice = price => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#038141',
      'B': '#85bb2f',
      'C': '#fecb02',
      'D': '#ee8100',
      'E': '#e63e11'
    };
    return colors[score?.toUpperCase()] || '#999';
  };
  const getProductEmoji = () => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('pizza') || name.includes('margherita')) return '🍕';
    if (name.includes('pasta') || name.includes('spaghet') || name.includes('lasagne')) return '🍝';
    if (name.includes('tiramisu') || name.includes('dessert')) return '🍰';
    if (name.includes('vin') || name.includes('vino')) return '🍷';
    if (name.includes('caffè') || name.includes('espresso')) return '☕';
    if (name.includes('insalata')) return '🥗';
    if (name.includes('gelato')) return '🍨';
    return '🍕';
  };
  const currentImage = images[currentImageIndex];
  const imageUrl = currentImage ? uri_transformer(currentImage.uri || currentImage.image_url || currentImage.url || currentImage) : null;
  const keyframes = `
        @keyframes pizzeriaModalIn {
            from { opacity: 0; transform: scale(0.92) translateY(15px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes pizzeriaShimmer {
            0% { background-position: -200% center; }
            100% { background-position: 200% center; }
        }
        @keyframes pizzeriaSpin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
        }
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap');
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: keyframes
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      onClick: handleClose,
      style: {
        position: 'fixed',
        inset: 0,
        background: 'rgba(10,5,2,0.92)',
        backdropFilter: 'blur(8px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 0.3s ease',
        padding: '1rem'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        onClick: e => e.stopPropagation(),
        style: {
          width: '100%',
          maxWidth: '380px',
          maxHeight: '90vh',
          background: `linear-gradient(160deg, ${backgroundColor} 0%, #0d0503 100%)`,
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: `
                            0 25px 80px rgba(0,0,0,0.6),
                            0 0 40px ${primaryColor}20,
                            inset 0 1px 0 rgba(255,255,255,0.1)
                        `,
          border: `2px solid ${primaryColor}30`,
          display: 'flex',
          flexDirection: 'column',
          transform: isVisible ? 'scale(1) translateY(0)' : 'scale(0.92) translateY(15px)',
          transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
          fontFamily: "'Playfair Display', Georgia, serif",
          position: 'relative'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '4px',
            background: `linear-gradient(90deg, ${secondaryColor} 33.33%, ${textColor} 33.33%, ${textColor} 66.66%, ${primaryColor} 66.66%)`,
            zIndex: 10
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: handleClose,
          style: {
            position: 'absolute',
            top: '12px',
            right: '12px',
            width: '36px',
            height: '36px',
            background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}cc 100%)`,
            border: 'none',
            borderRadius: '50%',
            color: '#fff',
            fontSize: '1.1rem',
            cursor: 'pointer',
            zIndex: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: `0 4px 15px ${primaryColor}50`,
            transition: 'all 0.2s ease'
          },
          children: "\u2715"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            position: 'relative',
            height: '200px',
            background: `linear-gradient(135deg, ${primaryColor}15 0%, ${secondaryColor}15 100%)`,
            overflow: 'hidden'
          },
          children: [imageUrl ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: imageUrl,
            alt: product.name,
            style: {
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '4rem',
              animation: 'pizzeriaSpin 10s linear infinite'
            },
            children: getProductEmoji()
          }), images.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i => i > 0 ? i - 1 : images.length - 1),
              style: {
                ...pizzeriaNavBtnStyle,
                left: '10px',
                background: `${primaryColor}dd`
              },
              children: "\u2039"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i => i < images.length - 1 ? i + 1 : 0),
              style: {
                ...pizzeriaNavBtnStyle,
                right: '10px',
                background: `${primaryColor}dd`
              },
              children: "\u203A"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                position: 'absolute',
                bottom: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '8px'
              },
              children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                onClick: () => setCurrentImageIndex(i),
                style: {
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  border: 'none',
                  background: i === currentImageIndex ? accentColor : 'rgba(255,255,255,0.5)',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }
              }, i))
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '60%',
              background: `linear-gradient(transparent, ${backgroundColor})`,
              pointerEvents: 'none'
            }
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            flex: 1,
            overflowY: 'auto',
            padding: '1.25rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              textAlign: 'center',
              marginBottom: '1rem'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                fontSize: '1.5rem',
                marginRight: '0.5rem'
              },
              children: getProductEmoji()
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
              style: {
                display: 'inline',
                fontSize: '1.4rem',
                fontWeight: 700,
                color: textColor,
                fontStyle: 'italic',
                margin: 0
              },
              children: product.name
            })]
          }), getDefaultPrice() !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              textAlign: 'center',
              marginBottom: '1rem'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                fontSize: '1.5rem',
                fontWeight: 700,
                color: accentColor,
                textShadow: `0 0 20px ${accentColor}50`
              },
              children: formatPrice(getDefaultPrice())
            })
          }), tags.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.5rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
              marginBottom: '1rem'
            },
            children: tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.3rem 0.7rem',
                fontSize: '0.7rem',
                background: `${secondaryColor}30`,
                color: secondaryColor,
                borderRadius: '12px',
                border: `1px solid ${secondaryColor}60`
              },
              children: tag
            }, i))
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '1rem',
              margin: '1rem 0',
              color: `${textColor}40`
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                flex: 1,
                height: '1px',
                background: `${primaryColor}30`
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                fontSize: '1rem'
              },
              children: "\uD83C\uDF55"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                flex: 1,
                height: '1px',
                background: `${primaryColor}30`
              }
            })]
          }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.9rem',
              lineHeight: 1.7,
              color: `${textColor}cc`,
              textAlign: 'center',
              fontStyle: 'italic',
              margin: '0 0 1rem'
            },
            children: product.description
          }), ingredients.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              marginBottom: '1rem'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
              style: {
                fontSize: '0.85rem',
                color: accentColor,
                margin: '0 0 0.5rem',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: '2px'
              },
              children: "\uD83E\uDDC0 Ingredienti"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              style: {
                fontSize: '0.8rem',
                color: `${textColor}aa`,
                textAlign: 'center',
                lineHeight: 1.6,
                margin: 0
              },
              children: ingredients.map(ing => ing.name || ing).join(' • ')
            })]
          }), allergens.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              marginBottom: '1rem'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
              style: {
                fontSize: '0.85rem',
                color: primaryColor,
                margin: '0 0 0.5rem',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: '2px'
              },
              children: "\u26A0\uFE0F Allergeni"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                gap: '0.4rem',
                flexWrap: 'wrap',
                justifyContent: 'center'
              },
              children: allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                style: {
                  padding: '0.25rem 0.6rem',
                  fontSize: '0.7rem',
                  background: `${primaryColor}20`,
                  color: primaryColor,
                  borderRadius: '10px',
                  border: `1px solid ${primaryColor}40`
                },
                children: allergen.name || allergen
              }, i))
            })]
          }), product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              textAlign: 'center',
              marginBottom: '1rem'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                display: 'inline-block',
                padding: '0.4rem 1rem',
                background: getNutriScoreColor(product.nutriscore),
                color: '#fff',
                borderRadius: '15px',
                fontSize: '0.8rem',
                fontWeight: 700
              },
              children: ["Nutri-Score: ", product.nutriscore.toUpperCase()]
            })
          }), prices.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              marginBottom: '1rem'
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
              style: {
                fontSize: '0.85rem',
                color: accentColor,
                margin: '0 0 0.5rem',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: '2px'
              },
              children: "\uD83D\uDCCF Formati"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                display: 'flex',
                gap: '0.5rem',
                flexWrap: 'wrap',
                justifyContent: 'center'
              },
              children: prices.map((priceItem, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                style: {
                  padding: '0.6rem 1rem',
                  background: i === 0 ? `${primaryColor}20` : 'transparent',
                  border: `2px solid ${i === 0 ? primaryColor : `${textColor}30`}`,
                  borderRadius: '12px',
                  textAlign: 'center',
                  minWidth: '80px'
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    fontSize: '0.65rem',
                    color: `${textColor}80`,
                    marginBottom: '0.2rem',
                    textTransform: 'uppercase'
                  },
                  children: priceItem.name || `Formato ${i + 1}`
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: i === 0 ? primaryColor : textColor
                  },
                  children: formatPrice(priceItem.price)
                })]
              }, i))
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              textAlign: 'center',
              marginTop: '1rem'
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                display: 'inline-block',
                padding: '0.5rem 1.2rem',
                background: product.is_available !== false ? `linear-gradient(135deg, ${secondaryColor} 0%, ${secondaryColor}cc 100%)` : '#666',
                color: '#fff',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: 600,
                boxShadow: product.is_available !== false ? `0 4px 15px ${secondaryColor}40` : 'none'
              },
              children: product.is_available !== false ? '✓ Disponibile' : '✗ Non disponibile'
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            padding: '1rem',
            borderTop: `2px solid ${primaryColor}30`,
            display: 'flex',
            justifyContent: 'center',
            background: `linear-gradient(180deg, transparent, ${primaryColor}10)`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: handleClose,
            style: {
              padding: '0.8rem 2.5rem',
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${primaryColor}cc 100%)`,
              border: 'none',
              borderRadius: '25px',
              color: '#fff',
              fontSize: '0.9rem',
              fontWeight: 700,
              fontFamily: "'Playfair Display', Georgia, serif",
              cursor: 'pointer',
              boxShadow: `0 6px 20px ${primaryColor}50`,
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            },
            children: "\uD83C\uDF55 Ordinare"
          })
        })]
      })
    })]
  });
};
const pizzeriaNavBtnStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '1.2rem',
  fontWeight: '900',
  color: '#fff',
  border: 'none',
  borderRadius: '50%',
  cursor: 'pointer',
  transition: 'all 0.2s ease'
};

// ============================================
// TEMPLATE PATISSERIE (Élégant & Gourmand)
// ============================================

const ProductDetailModalPatisserie = ({
  product,
  onClose,
  uri_transformer = url => url,
  styles_properties = {}
}) => {
  const [currentImageIndex, setCurrentImageIndex] = (0, _react.useState)(0);

  // Normaliser les propriétés
  const normalizedProps = normalizeStylesProperties(styles_properties);
  const {
    primaryColor = '#d4a5a5',
    // Rose poudré
    secondaryColor = '#8b6f5c',
    // Chocolat
    accentColor = '#f8e1e1',
    // Rose clair
    textColor = '#4a3728',
    // Marron foncé
    priceColor = '#d4a5a5',
    cardBackground = '#ffffff'
  } = normalizedProps;
  const images = product.images || [];
  const hasMultipleImages = images.length > 1;
  (0, _react.useEffect)(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  const handleBackdropClick = e => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const getDefaultImage = () => {
    if (!images || images.length === 0) return null;
    if (product.default_image_id) {
      const img = images.find(i => i.id === product.default_image_id);
      if (img) return img.image_url;
    }
    return images[0]?.image_url;
  };
  const getDefaultPrice = () => {
    if (!product.prices || product.prices.length === 0) return null;
    if (product.default_price_id) {
      const price = product.prices.find(p => p.id === product.default_price_id);
      if (price) return price.price;
    }
    return product.prices[0]?.price;
  };
  const formatPrice = price => {
    if (price === null || price === undefined) return '';
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(price);
  };
  const getNutriScoreColor = score => {
    const colors = {
      'A': '#22c55e',
      'B': '#84cc16',
      'C': '#eab308',
      'D': '#f97316',
      'E': '#ef4444'
    };
    return colors[score] || secondaryColor;
  };
  const getProductEmoji = () => {
    const name = (product.name || '').toLowerCase();
    if (name.includes('macaron')) return '🧁';
    if (name.includes('éclair') || name.includes('eclair')) return '🥖';
    if (name.includes('tarte')) return '🥧';
    if (name.includes('croissant')) return '🥐';
    if (name.includes('gâteau') || name.includes('gateau') || name.includes('cake')) return '🎂';
    if (name.includes('chocolat')) return '🍫';
    if (name.includes('mille-feuille') || name.includes('millefeuille')) return '🍰';
    if (name.includes('paris-brest')) return '🍩';
    if (name.includes('chou')) return '🧁';
    if (name.includes('fraise') || name.includes('framboise')) return '🍓';
    if (name.includes('citron')) return '🍋';
    if (name.includes('café') || name.includes('coffee')) return '☕';
    return '🧁';
  };
  const currentImage = images[currentImageIndex]?.image_url || getDefaultImage();
  const price = getDefaultPrice();
  const emoji = getProductEmoji();
  const modalKeyframes = `
        @keyframes patisserieModalIn {
            from { opacity: 0; transform: scale(0.9) translateY(20px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes patisserieBackdropIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    `;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `${textColor}80`,
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '1rem',
      boxSizing: 'border-box',
      animation: 'patisserieBackdropIn 0.3s ease-out'
    },
    onClick: handleBackdropClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: modalKeyframes
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        width: '100%',
        maxWidth: '550px',
        maxHeight: '90vh',
        background: `linear-gradient(145deg, ${cardBackground} 0%, ${accentColor}30 100%)`,
        borderRadius: '24px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: `0 25px 50px ${textColor}30`,
        animation: 'patisserieModalIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
        border: `3px solid ${primaryColor}40`,
        fontFamily: '"Playfair Display", Georgia, serif'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '1rem 1.25rem',
          background: `linear-gradient(90deg, ${primaryColor}20, ${accentColor}40, ${primaryColor}20)`,
          borderBottom: `2px solid ${primaryColor}30`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '1.5rem'
            },
            children: emoji
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '0.85rem',
              color: secondaryColor,
              fontStyle: 'italic'
            },
            children: "P\xE2tisserie Fine"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          onClick: onClose,
          style: {
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.1rem',
            color: secondaryColor,
            background: cardBackground,
            border: `2px solid ${primaryColor}40`,
            borderRadius: '50%',
            cursor: 'pointer',
            transition: 'all 0.2s ease'
          },
          children: "\u2715"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          position: 'relative',
          height: '280px',
          background: `linear-gradient(45deg, ${accentColor}50, ${primaryColor}20)`,
          flexShrink: 0
        },
        children: [currentImage ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: uri_transformer(currentImage),
          alt: product.name,
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            fontSize: '5rem'
          },
          children: emoji
        }), hasMultipleImages && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => prev === 0 ? images.length - 1 : prev - 1),
            style: {
              position: 'absolute',
              left: '0.75rem',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '40px',
              height: '40px',
              background: `${cardBackground}ee`,
              border: `2px solid ${primaryColor}`,
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '1rem',
              color: secondaryColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "\u25C0"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => setCurrentImageIndex(prev => (prev + 1) % images.length),
            style: {
              position: 'absolute',
              right: '0.75rem',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '40px',
              height: '40px',
              background: `${cardBackground}ee`,
              border: `2px solid ${primaryColor}`,
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '1rem',
              color: secondaryColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            children: "\u25B6"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              position: 'absolute',
              bottom: '0.75rem',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '8px'
            },
            children: images.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              onClick: () => setCurrentImageIndex(i),
              style: {
                width: '10px',
                height: '10px',
                background: i === currentImageIndex ? primaryColor : `${cardBackground}90`,
                border: `2px solid ${primaryColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                padding: 0
              }
            }, i))
          })]
        }), product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            padding: '0.4rem 0.8rem',
            background: `linear-gradient(135deg, ${secondaryColor}, ${primaryColor})`,
            color: '#fff',
            borderRadius: '20px',
            fontSize: '0.75rem',
            fontWeight: '600',
            boxShadow: `0 4px 15px ${secondaryColor}50`
          },
          children: "\u2B50 Coup de c\u0153ur"
        }), price !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            position: 'absolute',
            bottom: '1rem',
            right: '1rem',
            padding: '0.5rem 1rem',
            background: cardBackground,
            borderRadius: '12px',
            boxShadow: `0 4px 15px ${textColor}20`,
            border: `2px solid ${primaryColor}`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            style: {
              fontSize: '1.4rem',
              fontWeight: '700',
              color: secondaryColor
            },
            children: formatPrice(price)
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          flex: 1,
          overflowY: 'auto',
          padding: '1.25rem'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
            style: {
              fontSize: '1.5rem',
              fontWeight: '600',
              margin: '0 0 0.5rem',
              color: secondaryColor,
              fontStyle: 'italic'
            },
            children: product.name
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            style: {
              display: 'flex',
              gap: '0.5rem',
              flexWrap: 'wrap'
            },
            children: [product.nutriscore && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              style: {
                padding: '0.2rem 0.6rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                background: getNutriScoreColor(product.nutriscore),
                color: '#fff',
                borderRadius: '6px'
              },
              children: ["Nutri-Score ", product.nutriscore]
            }), product.is_available !== false ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.2rem 0.6rem',
                fontSize: '0.75rem',
                background: '#dcfce7',
                color: '#16a34a',
                borderRadius: '6px',
                fontWeight: '500'
              },
              children: "\u2713 Disponible"
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.2rem 0.6rem',
                fontSize: '0.75rem',
                background: '#fee2e2',
                color: '#dc2626',
                borderRadius: '6px',
                fontWeight: '500'
              },
              children: "\u2717 Indisponible"
            })]
          })]
        }), product.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            marginBottom: '1rem',
            padding: '1rem',
            background: `${accentColor}40`,
            borderRadius: '12px',
            borderLeft: `4px solid ${primaryColor}`
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.9rem',
              color: textColor,
              lineHeight: 1.7,
              margin: 0,
              fontStyle: 'italic'
            },
            children: product.description
          })
        }), product.tags?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8rem',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: '0.4rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.3rem'
            },
            children: "\uD83C\uDFF7\uFE0F Caract\xE9ristiques"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.4rem',
              flexWrap: 'wrap'
            },
            children: product.tags.map((tag, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.25rem 0.6rem',
                fontSize: '0.75rem',
                background: cardBackground,
                color: secondaryColor,
                borderRadius: '15px',
                border: `1px solid ${primaryColor}50`
              },
              children: tag
            }, i))
          })]
        }), product.allergens?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem',
            padding: '0.75rem',
            background: '#fef3c7',
            borderRadius: '10px',
            border: '1px solid #fbbf24'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8rem',
              fontWeight: '600',
              color: '#92400e',
              marginBottom: '0.4rem'
            },
            children: "\u26A0\uFE0F Allerg\xE8nes"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.4rem',
              flexWrap: 'wrap'
            },
            children: product.allergens.map((allergen, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                padding: '0.2rem 0.5rem',
                fontSize: '0.75rem',
                background: '#fff',
                color: '#b45309',
                borderRadius: '6px',
                fontWeight: '500'
              },
              children: allergen.name || allergen
            }, i))
          })]
        }), product.ingredients?.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8rem',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: '0.4rem'
            },
            children: "\uD83D\uDCDD Ingr\xE9dients"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              fontSize: '0.85rem',
              color: `${textColor}90`,
              margin: 0,
              lineHeight: 1.6
            },
            children: product.ingredients.join(' • ')
          })]
        }), product.prices?.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          style: {
            marginBottom: '1rem'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontSize: '0.8rem',
              fontWeight: '600',
              color: secondaryColor,
              marginBottom: '0.5rem'
            },
            children: "\uD83D\uDCB0 Tarifs"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              display: 'flex',
              gap: '0.6rem',
              flexWrap: 'wrap'
            },
            children: product.prices.map((p, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              style: {
                padding: '0.6rem 1rem',
                background: i === 0 ? `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})` : cardBackground,
                color: i === 0 ? '#fff' : textColor,
                borderRadius: '10px',
                textAlign: 'center',
                border: i === 0 ? 'none' : `2px solid ${primaryColor}40`,
                minWidth: '80px'
              },
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '0.7rem',
                  opacity: 0.8
                },
                children: p.name || 'Prix'
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontSize: '1.1rem',
                  fontWeight: '700'
                },
                children: formatPrice(p.price)
              })]
            }, i))
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          padding: '1rem',
          borderTop: `2px solid ${primaryColor}30`,
          background: `linear-gradient(90deg, ${accentColor}30, ${primaryColor}20, ${accentColor}30)`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.2rem'
          },
          children: "\uD83E\uDDC1"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '0.85rem',
            color: secondaryColor,
            fontStyle: 'italic'
          },
          children: "Fait avec amour & passion"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            fontSize: '1.2rem'
          },
          children: "\uD83E\uDDC1"
        })]
      })]
    })]
  });
};
var _default = exports.default = ProductDetailModal;